<template lang="pug">
main.py-3.px-5
  v-navigation-drawer.side-panel(v-model='C.state.panel.settings', width='680', right, clipped, temporary, fixed, hide-overlay)
    v-toolbar.transparent(tabs, flat, v-if='C.state.isEditable')
      v-layout.px-3(row, nowrap, fill-height, align-end)
        v-btn(@click='C.form.trigger.saveAll(false)', :disabled='!C.form.selected.invention.title', color='primary', dark)
          | {{ C.form.state.recentSaveActive ? 'Saved!' : 'Save' }}
    v-card.py-4.px-4
      v-layout.edit-inline.mb-3(row align-center)
        v-flex
          v-icon(color='secondary') title
        v-flex
          v-text-field(v-model='C.form.selected.invention.title', label='Title', :counter='100', solo)
      v-layout.edit-inline.mb-4(row align-center)
        v-flex.pt-0
          v-icon(color='secondary') business
        v-flex
          p.ma-0 {{ C.data.invention.organization && C.data.invention.organization.name }}
      v-layout.edit-inline(row)
        v-flex
          v-icon(color='secondary') add_to_photos
        v-flex
          v-select.input--box(v-model='C.form.selected.invention.invention_opportunity_id', single-line, label='Opportunity', v-bind:items='C.form.list.opportunities', item-text='title', item-value='id', :disabled='!C.state.isEditable')

      v-layout(row, wrap, v-if='C.state.isEditable && CR.show.unreleased')
        v-flex(xs12)
          v-text-field(v-model='C.form.selected.invention.$search.title', label='Add a Search', multi-line, auto-grow, rows="1", prepend-icon="search", v-on:focus='C.form.state.active.$search = true')

      transition(name='expand', v-if='C.state.isEditable && CR.show.unreleased')
        .mb-3(v-if="C.form.state.active.$search")
          v-flex(xs12)
            v-text-field(v-model='C.form.selected.invention.$search.url', label='Paste URL', multi-line, auto-grow, rows="1", prepend-icon="insert_link")
          v-flex(xs12)
            v-text-field(v-model='C.form.selected.invention.$search.note', label='Search Note', multi-line, auto-grow, rows="1", prepend-icon="note")
          v-flex(style="padding-left: 33px;")
            v-btn(color="primary", v-on:click='C.form.trigger.addSearchItem()') Add
            v-btn(v-on:click='C.form.state.active.$search = false') Cancel

      v-layout.mb-3(row, nowrap, align-start, v-for='(searchItem, searchItemIndex) in C.form.selected.invention.search', :key='searchItemIndex', v-if='CR.show.unreleased')
        v-icon youtube_searched_for
        v-flex.pl-4
          p.mb-0(v-if='!searchItem.url')
            | {{ searchItem.title }}
          a(:href='searchItem.url', target='_blank', v-if='searchItem.url')
            | {{ searchItem.title }}
          p.mb-0.grey--text {{ searchItem.note }}
        .search-list__close(v-if='C.state.isEditable')
          v-btn(@click='C.form.trigger.removeSearchItem(searchItem, searchItemIndex)', flat, icon, color='secondary', v-if='!searchItem.remove')
            v-icon close
          v-btn(@click='C.form.trigger.removeSearchItem(searchItem, searchItemIndex)', fab, small, icon, color='secondary', dark, v-if='searchItem.remove')
            v-icon close

      v-layout.edit-inline(row, v-if='C.state.isEditable')
        v-flex
          v-icon(color='secondary') comment
        v-flex
          v-select.input--box(v-model='C.form.selected.invention.bulk_read_access', hint="Bulk Read Access", persistent-hint, v-bind:items='C.form.list.bulkDefaultAccessOptions', item-text='label', item-value='value')
      v-layout.edit-inline(row, align-start, justify-space-between, v-if='C.state.isEditable')
        v-flex
          v-icon(color='secondary') people
        v-flex.mr-3(style='flex: 0 0 220px')
          v-select.input--box(v-model='C.form.selected.$collaborator.$item', single-line, label='User', autocomplete, v-bind:items='C.form.list.inventors | F_availableCollaborators(C.form.selected.co_inventors)', item-text='fullname', hide-details)
        v-flex
          v-select.input--box(v-model='C.form.selected.$collaborator.access', single-line, label='Access', v-bind:items='C.form.list.collaboratorAccessOptions.items | F_availableAccess(C.data.invention.phase)', item-text='label', item-value='value', hide-details)
        v-spacer
        v-flex(style='flex: 0 0 auto')
          v-btn.ma-0(color="secondary", v-on:click='C.form.trigger.addCollaboratorItem()')
            | Add Collaborator

      v-layout.edit-inline
        v-flex
        v-flex
          v-list(dense, v-for='(collaborator, collaboratorIndex) in C.form.selected.co_inventors', :key='collaborator.user_id')
            v-list-tile
              v-list-tile-content
                v-list-tile-title
                  h3(color='primary') {{ collaborator.$name }}
                v-list-tile-sub-title
                  | {{ collaborator.access && C.form.list.collaboratorAccessOptions.dictionary[collaborator.access.toString()] }}
              v-list-tile-action(v-if='C.state.isEditable')
                v-btn(@click='C.form.trigger.removeCollaboratorItem(collaborator, collaboratorIndex)', flat, icon, color='secondary', v-if='!collaborator.remove')
                  v-icon close
                v-btn(@click='C.form.trigger.removeCollaboratorItem(collaborator, collaboratorIndex)', fab, small, icon, color='secondary', dark, v-if='collaborator.remove')
                  v-icon close

  v-navigation-drawer.editor__leftpanel(app, permanent, fixed, floating, clipped, width="220")
    v-layout(column, fill-height, justify-space-between)
      v-flex
        v-list(dense)
          v-list-group(v-model='item.active', v-for='item in C.state.container', :key='item.title', append-icon='false', v-if='((C.data.invention.phase === "phase-2" && item.phaseThreshold <= 2) || (C.data.invention.phase === "phase-3" && item.phaseThreshold <= 3) || (C.data.invention.phase === "phase-4" && item.phaseThreshold <= 4) || (C.data.invention.phase === "phase-5" && item.phaseThreshold <= 5)) && !(item.unreleased && !CR.show.unreleased)')
            v-list-tile(slot='activator', :disabled="item.disabled", @click='C.form.trigger.selectContainerItem(item)')
              v-list-tile-content
                v-list-tile-title
                  | {{ item.title }}
            scrollactive(:offset="100", :duration="800", bezier-easing-value=".5,0,.35,1")
              v-list-tile(v-model='item.active', v-for='(subItem, subItemIndex) in item.items', :key='subItemIndex', :href='(item.componentContainerKey && subItem.useByIndex) ? `#${item.componentContainerKey}-${subItemIndex}` : subItem.href', @click='C.form.trigger.selectContainerSectionItem({subItem: subItem, item: item, index: subItemIndex})', active-class='scrollactive-item', v-if='(!item.componentContainerKey && !item.hideItemsList) || item.items.length > 1')
                v-list-tile-action
                  v-icon(v-if='(!item.componentContainerKey) && C.form.selected.invention.container_section[subItem.key] && C.form.selected.invention.container_section[subItem.key].completion')
                    | check
                  v-icon(v-if='(item.componentContainerKey && !subItem.notComponent) && C.form.selected.invention.container_section[`c_${item.componentContainerKey}`] && C.form.selected.invention.container_section[`c_${item.componentContainerKey}`].components && C.form.selected.invention.container_section[`c_${item.componentContainerKey}`].components[subItemIndex] && C.form.selected.invention.container_section[`c_${item.componentContainerKey}`].components[subItemIndex].completion')
                    | check
                  v-icon(v-if='(item.componentContainerKey && subItem.notComponent) && (C.evaluate.generalInfoIsChecked(subItem))')
                    | check
                v-list-tile-content
                  v-list-tile-title
                    | {{ subItem.title }}

      div
        v-list.mb-4
          v-list-tile(:to='{name: "Profile"}')
            v-list-tile-title
                v-list-tile-title
                  | Profile
          v-list-tile(@click='CR.trigger.signOut()')
            v-list-tile-title Sign Out

        v-list(dense).mb-3
          v-list-tile(avatar)
            avatar(:username='CR.authorization.data.fullname ? CR.authorization.data.fullname : "?"')
          v-list-tile(v-if='CR.authorization.data.email')
            v-list-tile-title
              .body-2
                | {{ CR.authorization.data.firstname }} {{ CR.authorization.data.lastname }}

        svg.ml-3(width='123', height='29', viewbox='0 0 123 29')
          g(fill='none', fill-rule='evenodd')
            path(d='M32 1.284h5.633c.836 0 1.621.083 2.355.249.734.165 1.373.441 1.917.828.545.387.975.9 1.29 1.538.316.64.474 1.424.474 2.355 0 .9-.162 1.68-.486 2.344a4.543 4.543 0 0 1-1.313 1.633 5.592 5.592 0 0 1-1.917.947 8.493 8.493 0 0 1-2.32.307H35.48v5.231H32V1.284zm5.42 7.432c1.894 0 2.84-.82 2.84-2.462 0-.804-.24-1.372-.722-1.704-.48-.331-1.187-.497-2.118-.497h-1.94v4.663h1.94zm11.745-.331h1.799c.915 0 1.613-.194 2.095-.58.48-.387.721-.959.721-1.716 0-.758-.24-1.286-.721-1.586-.482-.3-1.18-.45-2.095-.45h-1.799v4.332zm4.876 8.331l-2.959-5.562h-1.917v5.562h-3.48V1.284h5.563c.82 0 1.59.079 2.308.237.718.158 1.345.422 1.881.793.537.37.963.864 1.278 1.479.316.615.474 1.38.474 2.296 0 1.136-.249 2.07-.746 2.804a4.548 4.548 0 0 1-2 1.645l3.503 6.178h-3.905zM65.88 17c-1.042 0-1.993-.185-2.853-.556a6.201 6.201 0 0 1-2.213-1.598c-.615-.694-1.092-1.538-1.432-2.532-.339-.994-.509-2.123-.509-3.385 0-1.262.17-2.387.51-3.373.339-.986.816-1.814 1.431-2.485a6.147 6.147 0 0 1 2.213-1.538c.86-.355 1.81-.533 2.852-.533 1.042 0 1.992.178 2.852.533.86.355 1.598.871 2.213 1.55.616.678 1.093 1.51 1.432 2.497.34.986.51 2.102.51 3.349 0 1.262-.17 2.39-.51 3.385-.339.994-.816 1.838-1.432 2.532a6.201 6.201 0 0 1-2.213 1.598c-.86.37-1.81.556-2.852.556zm0-3.006c1.057 0 1.893-.454 2.508-1.36.616-.908.923-2.143.923-3.705 0-1.546-.307-2.753-.923-3.621-.615-.868-1.451-1.302-2.509-1.302-1.057 0-1.893.434-2.509 1.302-.615.868-.923 2.075-.923 3.621 0 1.562.308 2.797.923 3.704.616.907 1.452 1.361 2.51 1.361zm9.259-12.71h3.48v12.497h6.106v2.935H75.14V1.284zm11.603 0h3.48v15.432h-3.48V1.284zm6.467 0h9.728v2.935h-6.249v3.574h5.35v2.935h-5.35v5.988h-3.48V1.284zm11.745 0h3.479v15.432h-3.48V1.284zm5.733 7.81c0-1.277.197-2.417.591-3.42.395-1.001.927-1.85 1.598-2.544a6.775 6.775 0 0 1 2.343-1.586A7.43 7.43 0 0 1 118.05 1c.962 0 1.834.201 2.615.604.781.402 1.432.871 1.953 1.408L120.7 5.166a5.412 5.412 0 0 0-1.196-.852c-.402-.206-.872-.308-1.408-.308-.537 0-1.037.114-1.503.343a3.627 3.627 0 0 0-1.219.982c-.347.426-.62.947-.816 1.562-.198.616-.296 1.31-.296 2.083 0 1.594.339 2.829 1.017 3.704.679.876 1.586 1.314 2.722 1.314.631 0 1.184-.126 1.657-.379.473-.252.9-.583 1.278-.994l1.917 2.107c-.647.757-1.384 1.325-2.213 1.704a6.384 6.384 0 0 1-2.686.568 7.79 7.79 0 0 1-2.817-.509 6.576 6.576 0 0 1-2.32-1.503c-.662-.663-1.183-1.487-1.561-2.473-.379-.986-.568-2.126-.568-3.42z', fill='#222')
            path(d='M13.519 17.098L0 28.903v-27a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v14.195a1 1 0 0 1-1 1h-9.481zM5.833 5.53a.5.5 0 0 0-.5.5v6.44h12.834a.5.5 0 0 0 .5-.5V6.03a.5.5 0 0 0-.5-.5H5.833zm-.5 6.94v4.628l5.334-4.627H5.333z', fill='#00D732')

  v-toolbar.editor__nav.px-3(app, fixed, :clipped-left='true', :clipped-right='true')
    v-btn.hidden-xs-only.transparent(:to='{name: "Inventions"}', flat, color='secondary', icon)
      v-icon(medium) keyboard_arrow_left
    v-toolbar-title
      | {{ C.data.invention.title }} {{ C.form.state.recentSaveActive ? '(Saved!)' : '' }}
      v-layout(row, no-wrap, align-items-center)
        v-flex(v-if='C.data.invention.phase')
          v-layout(row, no-wrap, align-items-center)
            v-icon(small) check_circle
            p.body-2.mb-0.mr-3.ml-1
              | {{ C.dictionary.phase[C.data.invention.phase] }}

        v-flex(v-for='inventor in C.data.invention.co_inventors', :key='inventor.id')
          v-layout(row, no-wrap, align-items-center)
            v-icon(small) people
            p.body-2.mb-0.mr-3.ml-1
              | {{ inventor.user.fullname }}

        v-flex(v-if='C.data.invention.bulk_read_access')
          v-layout(row, no-wrap, align-items-center)
            p.body-2.mb-0.mr-4
              v-icon.mr-1(small) chat_bubble
              | {{ (C.data.invention.bulk_read_access && C.dictionary.bulk_read_access[C.data.invention.bulk_read_access]) ? C.dictionary.bulk_read_access[C.data.invention.bulk_read_access] : C.data.invention.bulk_read_access }}

        v-flex(v-if='C.data.invention.role')
          v-layout(row, no-wrap, align-items-center)
            p.body-2.mb-0.mr-4
              v-icon.mr-1(small) person
              | {{ C.data.invention.role }}

        v-flex(v-if='C.data.invention.opportunity')
          v-layout(row, no-wrap, align-items-center)
            p.body-2.mb-0.mr-4
              v-icon.mr-1(small) add_to_photos
              | {{ C.data.invention.opportunity && C.data.invention.opportunity.title }}

    v-spacer

    div.mr-3
      p.ma-0.mb-1 {{ C.report.checklist.percentage }}% Completed
      v-progress-linear.invention__progress.my-0(:value='C.report.checklist.percentage', color='primary', background-color='blue-grey lighten-5')

    v-dialog(v-model='C.state.dialog.checklist', max-width="680")
      v-btn(@click='C.trigger.openChecklist()', slot='activator', color='secondary', flat, icon, dark)
        v-icon
          | list
      v-card.px-4
        v-card-title.py-4
          v-layout(row nowrap justify-space-between)
            v-flex.headline
              | Invention Checklist
            div
              p.ma-0.mb-1 {{ C.report.checklist.percentage }}% Completed
              v-progress-linear.invention__progress.my-0(:value='C.report.checklist.percentage', color='primary',  background-color='blue-grey lighten-5')
        v-card-text
          v-tabs.invention-checklist(v-model='C.state.tab.checklist.active', :is-booted='true', slider-color='primary')
            v-tab(:href='`#checklist-summary`', :ripple="false")
              | Summary
            v-tab(:href='`#checklist-detailed`', :ripple="false")
              | Detailed Checklist
            v-tabs-items(v-model='C.state.tab.checklist.item')

              v-tab-item.pt-3(:id='`checklist-summary`')
                ul
                  li
                    .subheading
                      | Invention Concept
                      span.primary(v-if='C.data.invention.phase === "phase-2" || C.data.invention.phase === "phase-3" || C.data.invention.phase === "phase-4" || C.data.invention.phase === "phase-5"')
                        | Complete
                      span.grey(v-if='C.data.invention.phase === "phase-1"')
                        | Current

                  li
                    .subheading
                      | Invention Brief
                      span.primary(v-if='C.data.invention.phase === "phase-3" || C.data.invention.phase === "phase-4" || C.data.invention.phase === "phase-5"')
                        | Complete
                      span.grey(v-if='C.data.invention.phase === "phase-2"')
                        | Current
                    ul
                      li(v-bind:class='{"js-checklist-checked": C.report.checklist.overview.brief.completionAll}')
                        v-icon(small) check
                        | Complete content sections for all containers in this phase
                      li(v-bind:class='{"js-checklist-checked": C.report.checklist.overview.brief.searchOne}')
                        v-icon(small) check
                        | Perform&nbsp;
                        a.text-link(@click='C.state.dialog.checklist = false; C.state.tab.inventionNotesSidepanel.active = "tab-keywords";')
                          | one search

                  li
                    .subheading
                      | Invention Full
                      span.primary(v-if='C.data.invention.phase === "phase-4" || C.data.invention.phase === "phase-5"')
                        | Complete
                      span.grey(v-if='C.data.invention.phase === "phase-3"')
                        | Current
                    ul
                      li(v-bind:class='{"js-checklist-checked": C.report.checklist.overview.full.completionAll}')
                        v-icon(small) check
                        | Complete content sections for all containers in this phase
                      li(v-bind:class='{"js-checklist-checked": C.report.checklist.overview.full.searchTwo}')
                        v-icon(small) check
                        | Perform total of&nbsp;
                        a.text-link(@click='C.state.dialog.checklist = false; C.state.tab.inventionNotesSidepanel.active = "tab-keywords";')
                          | two or more searches
                      li(v-bind:class='{"js-checklist-checked": C.report.checklist.overview.full.mentorOne}')
                        v-icon(small) check
                        a.text-link(@click='C.state.dialog.checklist = false; C.state.panel.settings = true;')
                          | Add your mentor

                  li
                    .subheading
                      | Invention Review
                      span.primary(v-if='C.data.invention.phase === "phase-5"')
                        | Complete
                      span.grey(v-if='C.data.invention.phase === "phase-4"')
                        | Current
                    ul
                      li(v-bind:class='{"js-checklist-checked": C.data.invention.phase === "phase-5"}')
                        v-icon(small) check
                        | Mentor sign off on invention

                  li
                    .subheading
                      | Invention Complete
                      span.primary(v-if='C.data.invention.phase === "phase-5"')
                        | Complete

              v-tab-item.pt-3(:id='`checklist-detailed`')
                ol
                  li
                    .subheading
                      | Invention Concept
                      span.primary(v-if='C.data.invention.phase === "phase-2" || C.data.invention.phase === "phase-3" || C.data.invention.phase === "phase-4" || C.data.invention.phase === "phase-5"')
                        | Complete
                      span.grey(v-if='C.data.invention.phase === "phase-1"')
                        | Current
                    ul
                      li(v-bind:class='{"js-checklist-checked": !!(C.form.selected.invention.title)}')
                        v-icon(small) check
                        | Title
                      li(v-bind:class='{"js-checklist-checked": !!(C.form.selected.invention.description)}')
                        v-icon(small) check
                        | Description
                      li(v-bind:class='{"js-checklist-checked": !!(C.form.selected.invention.invention_opportunity_id)}')
                        v-icon(small) check
                        | Opportunity

                  li
                    .subheading
                      | Invention Brief
                      span.primary(v-if='C.data.invention.phase === "phase-3" || C.data.invention.phase === "phase-4" || C.data.invention.phase === "phase-5"')
                        | Complete
                      span.grey(v-if='C.data.invention.phase === "phase-2"')
                        | Current
                    ul
                      li(v-bind:class='{"js-checklist-checked": (C.report.checklist.detailed.containerSections.summary && C.report.checklist.detailed.containerSections.draw && C.report.checklist.detailed.containerSections.significance)}')
                        v-icon(small) check
                        | Solution
                      li(v-bind:class='{"js-checklist-checked": (C.report.checklist.detailed.containerSections.problem_summary && C.report.checklist.detailed.containerSections.gap && C.report.checklist.detailed.containerSections.problem_significance)}')
                        v-icon(small) check
                        | Problem
                      li(v-bind:class='{"js-checklist-checked": (C.report.checklist.detailed.searchCount.one)}')
                        v-icon(small) check
                        | Perform&nbsp;
                        a.text-link(@click='C.state.dialog.checklist = false; C.state.tab.inventionNotesSidepanel.active = "tab-keywords";')
                          | one search
                  li
                    .subheading
                      | Invention Full
                      span.primary(v-if='C.data.invention.phase === "phase-4" || C.data.invention.phase === "phase-5"')
                        | Complete
                      span.grey(v-if='C.data.invention.phase === "phase-3"')
                        | Current
                    ul
                      li(v-bind:class='{"js-checklist-checked": (C.report.checklist.detailed.containerSections.landscape && C.report.checklist.detailed.containerSections.comparativeadvantages_innovativeaspects && C.report.checklist.detailed.containerSections.comparativeadvantages_advantagessummary && C.report.checklist.detailed.containerSections.comparativeadvantages_relevantbackground && !!C.report.checklist.detailed.componentContainers.c_comparativeadvantages.complete && (C.report.checklist.detailed.componentContainers.c_comparativeadvantages.complete === C.report.checklist.detailed.componentContainers.c_comparativeadvantages.amount))}')
                        v-icon(small) check
                        | Comparative Advantages
                      li(v-bind:class='{"js-checklist-checked": (C.report.checklist.detailed.containerSections.construction_howused && !!C.report.checklist.detailed.componentContainers.c_construction.complete && (C.report.checklist.detailed.componentContainers.c_construction.complete === C.report.checklist.detailed.componentContainers.c_construction.amount))}')
                        v-icon(small) check
                        | Construction
                      li(v-bind:class='{"js-checklist-checked": (C.report.checklist.detailed.containerSections.economics_need && C.report.checklist.detailed.containerSections.economics_enduser && C.report.checklist.detailed.containerSections.economics_keyresources && C.report.checklist.detailed.containerSections.economics_capitalexpenditure && C.report.checklist.detailed.containerSections.economics_feasiblyeconomical && C.report.checklist.detailed.containerSections.economics_whomake && C.report.checklist.detailed.containerSections.economics_howmakemoney && C.report.checklist.detailed.containerSections.economics_howdelivered && C.report.checklist.detailed.containerSections.economics_economicburden && C.report.checklist.detailed.containerSections.economics_currentsolutioncosts && C.report.checklist.detailed.containerSections.economics_consumercosts)}')
                        v-icon(small) check
                        | Economics
                      li(v-bind:class='{"js-checklist-checked": (!!C.report.checklist.detailed.componentContainers.c_development.complete && (C.report.checklist.detailed.componentContainers.c_development.complete === C.report.checklist.detailed.componentContainers.c_development.amount))}')
                        v-icon(small) check
                        | Development
                      li(v-bind:class='{"js-checklist-checked": (C.report.checklist.detailed.containerSections.specificquestions)}')
                        v-icon(small) check
                        | Specific Questions
                      li(v-bind:class='{"js-checklist-checked": (C.report.checklist.detailed.containerSections.references)}')
                        v-icon(small) check
                        | References
                      li(v-bind:class='{"js-checklist-checked": C.report.checklist.detailed.searchCount.two}')
                        v-icon(small) check
                        | Perform total of&nbsp;
                        a.text-link(@click='C.state.dialog.checklist = false; C.state.tab.inventionNotesSidepanel.active = "tab-keywords";')
                          | two or more searches
                      li(v-bind:class='{"js-checklist-checked": C.report.checklist.detailed.mentorCount.one}')
                        v-icon(small) check
                        a.text-link(@click='C.state.dialog.checklist = false; C.state.panel.settings = true;')
                          | Add your mentor

                  li
                    .subheading
                      | Invention Review
                      span.primary(v-if='C.data.invention.phase === "phase-5"')
                        | Complete
                      span.grey(v-if='C.data.invention.phase === "phase-4"')
                        | Current
                    ul
                      li(v-bind:class='{"js-checklist-checked": C.data.invention.phase === "phase-5"}')
                        v-icon(small) check
                        | Mentor sign off on invention

                  li
                    .subheading
                      | Invention Complete
                      span.primary(v-if='C.data.invention.phase === "phase-5"')
                        | Complete

    v-btn(@click.stop='C.state.panel.settings = !C.state.panel.settings;', color='secondary', flat, icon, dark, v-if='C.state.isEditable')
      v-icon settings
    v-btn(@click='C.form.trigger.markInventionComplete()', color='info', v-if='C.data.invention.phase === "phase-4" && C.data.invention.role === "Mentor"')
      | Complete
    v-btn(@click='C.form.trigger.saveAll(true)', :disabled='!C.form.selected.invention.title', color='secondary', dark, v-if='C.state.isEditable')
      | Present
    v-btn(:to='{name: "InventionPresentation", params: { id: this.$route.params.id }}', color='secondary', dark, v-if='!C.state.isEditable')
      | Present



  v-alert.mt-1.mb-4(type='error', :value='true', v-if='!C.form.selected.invention.title && C.state.isEditable')
    span
      | Title is unavailable!



  div(v-if='C.state.container[0].active')
    .invention__title
      .title The Solution

    section.invention__section#solution-summary
      v-layout
        v-flex
          .subheading.mb-0
            | Solution Summary
            basic-tooltip(message='Summarize the essence of your solution clearly and briefly.  What is the key advancement or core invention?   Reviewers will ask: "What is the actual technical advancement, improvement or innovative step provided by this solution?"')
        completion-check(section-id='summary', :section-item='C.form.selected.invention.container_section.summary', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.summary.content')
      froala(v-model='C.form.selected.invention.container_section.summary.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.summary.content', v-if='!C.state.isEditable')

    section.invention__section#solution-draw
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | Draw
            basic-tooltip(message='Draw and upload an illustrative overview of the core of the invention. Someone should be able to look at this picture and understand exactly what the invention is.')
        completion-check(section-id='draw', :section-item='C.form.selected.invention.container_section.draw', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.draw.content')
      froala(v-model='C.form.selected.invention.container_section.draw.content', :config='C.form.config.froala.invention.container_section.draw.content', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.draw.content', v-if='!C.state.isEditable')

    section.invention__section#solution-significance
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | Significance
            basic-tooltip(message='In one or two sentences, what is the significant technical advancement or inventive step?')
        completion-check(section-id='significance', :section-item='C.form.selected.invention.container_section.significance', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.significance.content')
      froala(v-model='C.form.selected.invention.container_section.significance.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.significance.content', v-if='!C.state.isEditable')





  div(v-if='C.state.container[1].active')
    .invention__title
      .title The Problem

    section.invention__section#problem-summary
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | Problem Summary
            basic-tooltip(message='Write a brief statement on exactly what the specific problem is that you have solved.  Every solution targets a certain problem. Please use this section to highlight the specific problem the solution addresses. This section can be as short or as long as needed to describe the precise problem the solution addresses.')
        completion-check(section-id='problem_summary', :section-item='C.form.selected.invention.container_section.problem_summary', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.problem_summary.content')
      froala(v-model='C.form.selected.invention.container_section.problem_summary.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.problem_summary.content', v-if='!C.state.isEditable')

    section.invention__section#problem-gap
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | Gap
            basic-tooltip(message='What is the current technology in this area, and why doesn’t it solve the problem, i.e. what are the specific shortcomings?   Summarize in one or two sentences.')
        completion-check(section-id='gap', :section-item='C.form.selected.invention.container_section.gap', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.gap.content')
      froala(v-model='C.form.selected.invention.container_section.gap.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.gap.content', v-if='!C.state.isEditable')

    section.invention__section#problem-significance
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | Significance
            basic-tooltip(message='Why is this important to solve and what would it look like if this solution was available?   Summarize in one or two sentences.')
        completion-check(section-id='problem_significance', :section-item='C.form.selected.invention.container_section.problem_significance', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.problem_significance.content')
      froala(v-model='C.form.selected.invention.container_section.problem_significance.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.problem_significance.content', v-if='!C.state.isEditable')





  div(v-if='C.state.container[2].active')
    template
      v-layout(row='', justify-center='')
        v-dialog(v-model='C.state.dialog.confirmComparativeadvantagesComponentDelete.active', max-width='290')
          v-card
            v-card-title.headline
              | Notice
            v-card-text
              | Do you wish to delete this technology?
            v-card-actions
              v-spacer
              v-btn(color='green darken-1', flat='flat', @click.native='C.state.dialog.confirmComparativeadvantagesComponentDelete.active = false')
                | Cancel
              v-btn(color='green darken-1', flat='flat', @click.native='C.trigger.confirmComparativeadvantagesComponentDelete()')
                | Confirm

    v-tabs.construction-tabs(v-model='C.state.tab.comparativeadvantages.active', :is-booted='true', slider-color='primary')
      v-tab.hide(:href='`#comparativeadvantages-base`', :ripple="false")
        | Base
      v-tab.hide(v-for='(component, componentIndex) in C.form.selected.invention.container_section.c_comparativeadvantages.components', :key='componentIndex' :href='`#comparativeadvantages-${componentIndex}`', :ripple="false")
        | {{ component.type }}
      v-tab.hide(:href='`#comparativeadvantages-general`', :ripple="false")
        | General
      v-tabs-items(v-model='C.state.tab.comparativeadvantages.item')

        v-tab-item.construction.pt-0(:id='`comparativeadvantages-base`')
          .invention__title(v-if='C.state.isEditable')
            .title
              | Comparative Advantages Overview

          section.invention__section#comparativeadvantages_landscape
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Landscape
                  basic-tooltip(message='Describe the landscape of competing technologies, methods, or products. ')
              completion-check(section-id='landscape', :section-item='C.form.selected.invention.container_section.landscape', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.landscape.content')
            froala(v-model='C.form.selected.invention.container_section.landscape.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='C.form.selected.invention.container_section.landscape.content', v-if='!C.state.isEditable')

          section.invention__section#comparativeadvantages_innovativeaspects
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Innovative Aspects
                  basic-tooltip(message='What are the innovative aspects of the invention and why hasn’t anyone thought of this before?')
              .d-inline-flex
                completion-check(section-id='comparativeadvantages_innovativeaspects', :section-item='C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.content')
            froala(v-model='C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.content', v-if='!C.state.isEditable')

        v-tab-item.construction.pt-0(v-for='(component, componentIndex) in C.form.selected.invention.container_section.c_comparativeadvantages.components', :key='componentIndex', :id='`comparativeadvantages-${componentIndex}`')
          section
            .invention__title.invention__title--actions
              v-layout(row, no-wrap, align-end)
                v-flex
                  .title.text--capitalize.pb-2
                    | {{ component.type }}
                .d-inline-flex
                  v-tooltip(bottom)
                    v-btn(@click='C.form.trigger.deleteComparativeadvantagesComponent(component)', :flat='!component.delete', :outline='!component.delete', :fab='component.delete', :small='component.delete', :dark='component.delete', icon, color='secondary', slot="activator", v-if='C.state.isEditable')
                      v-icon(small) delete
                    span Delete
                  completion-check(section-id='c_comparativeadvantages', :component-id='component.id', :section-item='component', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='component.id && component.items.competing_howworks.content && component.items.shortcomings.content && component.items.howovercomes_shortcomings.content')
          section(v-if='C.state.isEditable')
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Title
            v-text-field.mb-3(v-model='component.type', @input='C.form.event.typeAutoSave()', label='Title', :counter='100', solo)
          section.invention__section
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Describe a competing technology and how it works?
                  v-icon.ml-2(v-if='component.items.competing_howworks.content && CR.show.unreleased', small, color='primary')
                    | check_circle
            froala(v-model='component.items.competing_howworks.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='component.items.competing_howworks.content', v-if='!C.state.isEditable')
          section.invention__section
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Describe the shortcomings of the {{ component.type }}.
                  v-icon.ml-2(v-if='component.items.shortcomings.content && CR.show.unreleased', small, color='primary')
                    | check_circle
            froala(v-model='component.items.shortcomings.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='component.items.shortcomings.content', v-if='!C.state.isEditable')
          section.invention__section
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Describe how your invention overcomes the specific shortcomings.
                  v-icon.ml-2(v-if='component.items.howovercomes_shortcomings.content && CR.show.unreleased', small, color='primary')
                    | check_circle
            froala(v-model='component.items.howovercomes_shortcomings.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='component.items.howovercomes_shortcomings.content', v-if='!C.state.isEditable')

        v-tab-item.construction.pt-0(:id='`comparativeadvantages-general`')
          section#comparativeadvantages-general
            .invention__title
              v-layout(row, align-center)
                v-flex
                  .title
                    | Comparative Advantages General

          section.invention__section#comparativeadvantages_advantagessummary
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Comparative Advantages Summary
                  basic-tooltip(message='Write a paragraph summarizing your listed current technologies. Reviewers will ask: "How is the solution potentially better than what is out there? How is it different from what has been done before (or described in the literature)?"')
              .d-inline-flex
                completion-check(section-id='comparativeadvantages_advantagessummary', :section-item='C.form.selected.invention.container_section.comparativeadvantages_advantagessummary', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.content')
            froala(v-model='C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.content', v-if='!C.state.isEditable')

          section.invention__section#comparativeadvantages_relevantbackground
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Relevant Background
                  basic-tooltip(message='This section is used to highlight information that can be used by the reviewers or patent attorney to help put the solution in proper context. This section is specifically reserved for other people’s work (please include competitive work) as well as your past work that you believe will aid the reviewers in understanding the technical landscape.  Background can be in a paragraph format or listed.  Data related to or supporting your solution should NOT be in this section, it should be in the next section Construction')
              .d-inline-flex
                completion-check(section-id='comparativeadvantages_relevantbackground', :section-item='C.form.selected.invention.container_section.comparativeadvantages_relevantbackground', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.content')
            froala(v-model='C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.content', v-if='!C.state.isEditable')

    section(v-if='C.state.isEditable')
      v-container.pa-0(fluid, style='margin-left: -1.75em')

        v-layout(row, wrap, align-center)
          v-flex(xs4)
            v-btn(flat, color='primary', @click='C.form.trigger.addComparativeadvantagesComponent()')
              v-icon.mr-2 add_circle
              | Add{{ C.form.selected.invention.container_section.c_comparativeadvantages.components.length === 0 ? "" : " Another" }} Current Technology
            v-btn(flat, color='secondary' @click='C.state.tab.comparativeadvantages.active = "comparativeadvantages-general"; C.trigger.scrollToTop();', v-if='C.state.tab.comparativeadvantages.active !== "comparativeadvantages-base" && C.state.tab.comparativeadvantages.active !== "comparativeadvantages-general"')
              v-icon.mr-2 check_circle
              | Complete the General Info Section





  div(v-if='C.state.container[3].active')
    template
      v-layout(row='', justify-center='')
        v-dialog(v-model='C.state.dialog.confirmConstructionComponentDelete.active', max-width='290')
          v-card
            v-card-title.headline
              | Notice
            v-card-text
              | Do you wish to delete this element?
            v-card-actions
              v-spacer
              v-btn(color='green darken-1', flat='flat', @click.native='C.state.dialog.confirmConstructionComponentDelete.active = false')
                | Cancel
              v-btn(color='green darken-1', flat='flat', @click.native='C.trigger.confirmConstructionComponentDelete()')
                | Confirm

    v-tabs.construction-tabs(v-model='C.state.tab.construction.active', :is-booted='true', slider-color='primary')
      v-tab.hide(:href='`#construction-base`', :ripple="false")
        | Base
      v-tab.hide(v-for='(component, componentIndex) in C.form.selected.invention.container_section.c_construction.components', :key='componentIndex' :href='`#construction-${componentIndex}`', :ripple="false")
        | {{ component.type }}
      v-tab.hide(:href='`#construction-general`', :ripple="false")
        | General
      v-tabs-items(v-model='C.state.tab.construction.item')

        v-tab-item.construction.pt-0(:id='`construction-base`')
          .invention__title(v-if='C.state.isEditable')
            .title How Is The Invention Used and Made
          section.invention__section(v-if='C.state.isEditable')
            v-layout(row, wrap, align-center)
              v-flex
                ol
                  li: p
                    | Using this hierarchy of categories, from service level down to material level, check the box for the category that most accurately describes the inventive element of your solution.
                  li: p
                    | If your solution contains multiple inventive elements, choose the element highest up in the hierarchy first and work down from there, making only a single selection for each multiple choice.
                  li: p
                    | Then, using complete sentences, describe that inventive element by answering the subsequent questions in detail.
                  li: p
                    | This section should focus on how the solution is made; how it is used is addressed in the next section.
                p
                  | Select what type of invention it is.  Make only one selection, starting with the highest level of the invention.  Continue to the next multiple choice question if you have more than one inventive element (they will appear as you progress).

        v-tab-item.construction.pt-0(v-for='(component, componentIndex) in C.form.selected.invention.container_section.c_construction.components', :key='componentIndex', :id='`construction-${componentIndex}`')
          section.invention__section
            .invention__title.invention__title--actions
              v-layout(row, no-wrap, align-end)
                v-flex
                  .title.text--capitalize.pb-2
                    | {{ component.type }}
                .d-inline-flex
                  v-tooltip(bottom, v-if='component.type !== "construction"')
                    v-btn(@click='C.form.trigger.deleteConstructionComponent(component)', :flat='!component.delete', :outline='!component.delete', :fab='component.delete', :small='component.delete', :dark='component.delete', icon, color='secondary', slot="activator", v-if='C.state.isEditable')
                      v-icon(small) delete
                    span Delete
                  completion-check(section-id='c_construction', :component-id='component.id', :section-item='component', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='component.id && component.items.ideal_example.content && component.items.properties.content && component.items.how_made.content')
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | What is it?
                  basic-tooltip(message='How does the solution work? What is an ideal example and alternatives.')
                  v-icon.ml-2(v-if='component.items.ideal_example.content && CR.show.unreleased', small, color='primary')
                    | check_circle
            froala(v-model='component.items.ideal_example.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='component.items.ideal_example.content', v-if='!C.state.isEditable')
          section.invention__section
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | What are the properties?
                  basic-tooltip(message='List systems/methods and/or material(s).')
                  v-icon.ml-2(v-if='component.items.properties.content && CR.show.unreleased', small, color='primary')
                    | check_circle
            froala(v-model='component.items.properties.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='component.items.properties.content', v-if='!C.state.isEditable')
          section.invention__section
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | How is it made?
                  basic-tooltip(message='Focus on how you would make, assemble, synthesize or build the solution. How it is "used" will be detailed in next section.')
                  v-icon.ml-2(v-if='component.items.how_made.content && CR.show.unreleased', small, color='primary')
                    | check_circle
            froala(v-model='component.items.how_made.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='component.items.how_made.content', v-if='!C.state.isEditable')

        v-tab-item.construction.pt-0(:id='`construction-general`')
          section#construction-general
            .invention__title
              v-layout(row, align-center)
                v-flex
                  .title
                    | Construction General

          section.invention__section#construction-howused
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | How is it used?
              .d-inline-flex
                completion-check(section-id='construction_howused', :section-item='C.form.selected.invention.container_section.construction_howused', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.construction_howused.content')
            froala(v-model='C.form.selected.invention.container_section.construction_howused.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='C.form.selected.invention.container_section.construction_howused.content', v-if='!C.state.isEditable')

          section.invention__section#construction-prototype
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Prototype (Optional)
                  basic-tooltip(message='Attach any relevant data in the form of graphs, tables, figures, photos, etc')
              .d-inline-flex
                completion-check(section-id='construction_prototype', :section-item='C.form.selected.invention.container_section.construction_prototype', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable')
            froala(v-model='C.form.selected.invention.container_section.construction_prototype.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='C.form.selected.invention.container_section.construction_prototype.content', v-if='!C.state.isEditable')

    section(v-if='C.state.isEditable')
      v-layout(row, align-center)
        v-flex
          .subheading.mb-2
            | Add {{ C.state.tab.construction.active === "construction-base" ? "an" : "another" }} inventive element
      v-container.pa-0(fluid, style='margin-left: -1.75em')
        v-layout(row, wrap, align-center)
          v-flex(xs4, v-for='componentOption in C.form.list.constructionComponentOptions', :key='componentOption.key', @click='C.form.trigger.addConstructionComponent(componentOption.key)')
            v-btn(flat, color='primary')
              v-icon.mr-2 add_circle
              | {{ componentOption.label }}

      v-card.mt-4(v-if='C.state.tab.construction.active !== "construction-base" && C.state.tab.construction.active !== "construction-general"')
        v-card-text.py-2
          v-layout(row, align-center)
            v-flex
              .subheading.mb-0
                | Done adding inventive elements?
              p
                a(@click='C.state.tab.construction.active = "construction-general"; C.trigger.scrollToTop();')
                  | Complete the "General Section"





  div(v-if='C.state.container[4].active')
    .invention__title
      .title Economics

    section.invention__section#economics-need
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | What is the actual market need?
        completion-check(section-id='economics_need', :section-item='C.form.selected.invention.container_section.economics_need', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.economics_need.content')
      froala(v-model='C.form.selected.invention.container_section.economics_need.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.economics_need.content', v-if='!C.state.isEditable')

    section.invention__section#economics-enduser
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | Who is the end user?
        completion-check(section-id='economics_enduser', :section-item='C.form.selected.invention.container_section.economics_enduser', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.economics_enduser.content')
      froala(v-model='C.form.selected.invention.container_section.economics_enduser.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.economics_enduser.content', v-if='!C.state.isEditable')

    section.invention__section#economics-keyresources
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | What are the key resources needed to commercialize this invention?
        completion-check(section-id='economics_keyresources', :section-item='C.form.selected.invention.container_section.economics_keyresources', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.economics_keyresources.content')
      froala(v-model='C.form.selected.invention.container_section.economics_keyresources.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.economics_keyresources.content', v-if='!C.state.isEditable')

    section.invention__section#economics-capitalexpenditure
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | What are the estimated capital expenditure requirements to make the first unit?
            basic-tooltip(message='For example, can this be made with existing production capabilities (e.e. small CAPEX), does there need to be modifications to existing lines (medium CAPEX), or does a whole new production method need to be built (large CAPEX). Try to estimate a value if possible (e.g. is it 5K, $500K or $5M to build a line to make product at scale?)')
        completion-check(section-id='economics_capitalexpenditure', :section-item='C.form.selected.invention.container_section.economics_capitalexpenditure', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.economics_capitalexpenditure.content')
      froala(v-model='C.form.selected.invention.container_section.economics_capitalexpenditure.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.economics_capitalexpenditure.content', v-if='!C.state.isEditable')

    section.invention__section#economics-feasiblyeconomical
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | Is it feasible that this solution can be delivered economically?
        completion-check(section-id='economics_feasiblyeconomical', :section-item='C.form.selected.invention.container_section.economics_feasiblyeconomical', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.economics_feasiblyeconomical.content')
      froala(v-model='C.form.selected.invention.container_section.economics_feasiblyeconomical.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.economics_feasiblyeconomical.content', v-if='!C.state.isEditable')

    section.invention__section#economics-whomake
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | Ideally, who will make this invention?
        completion-check(section-id='economics_whomake', :section-item='C.form.selected.invention.container_section.economics_whomake', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.economics_whomake.content')
      froala(v-model='C.form.selected.invention.container_section.economics_whomake.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.economics_whomake.content', v-if='!C.state.isEditable')

    section.invention__section#economics-howmakemoney
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | How do they make money from this technology?
            basic-tooltip(message='Top line: product, extension, aftermarket, service, data, advertising. Bottom line: cost saving, labor saving, safety, etc.')
        completion-check(section-id='economics_howmakemoney', :section-item='C.form.selected.invention.container_section.economics_howmakemoney', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.economics_howmakemoney.content')
      froala(v-model='C.form.selected.invention.container_section.economics_howmakemoney.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.economics_howmakemoney.content', v-if='!C.state.isEditable')

    section.invention__section#economics-howdelivered
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | How will the product/service be delivered to the consumer?
        completion-check(section-id='economics_howdelivered', :section-item='C.form.selected.invention.container_section.economics_howdelivered', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.economics_howdelivered.content')
      froala(v-model='C.form.selected.invention.container_section.economics_howdelivered.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.economics_howdelivered.content', v-if='!C.state.isEditable')

    section.invention__section#economics-economicburden
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | What is the economic burden of the problem?
        completion-check(section-id='economics_economicburden', :section-item='C.form.selected.invention.container_section.economics_economicburden', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.economics_economicburden.content')
      froala(v-model='C.form.selected.invention.container_section.economics_economicburden.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.economics_economicburden.content', v-if='!C.state.isEditable')

    section.invention__section#economics-currentsolutioncosts
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | If there are current solutions, what do they cost?
            basic-tooltip(message='Competitors may be direct or indirect.')
        completion-check(section-id='economics_currentsolutioncosts', :section-item='C.form.selected.invention.container_section.economics_currentsolutioncosts', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.economics_currentsolutioncosts.content')
      froala(v-model='C.form.selected.invention.container_section.economics_currentsolutioncosts.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.economics_currentsolutioncosts.content', v-if='!C.state.isEditable')

    section.invention__section#economics-consumercosts
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | Would the consumer pay for your solution?
            basic-tooltip(message='If so, why? If not, how do you make money from the inventions?')
        completion-check(section-id='economics_consumercosts', :section-item='C.form.selected.invention.container_section.economics_consumercosts', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.economics_consumercosts.content')
      froala(v-model='C.form.selected.invention.container_section.economics_consumercosts.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.economics_consumercosts.content', v-if='!C.state.isEditable')





  div(v-if='C.state.container[5].active')
    template
      v-layout(row='', justify-center='')
        v-dialog(v-model='C.state.dialog.confirmDevelopmentComponentDelete.active', max-width='290')
          v-card
            v-card-title.headline
              | Notice
            v-card-text
              | Do you wish to delete this milestone?
            v-card-actions
              v-spacer
              v-btn(color='green darken-1', flat='flat', @click.native='C.state.dialog.confirmDevelopmentComponentDelete.active = false')
                | Cancel
              v-btn(color='green darken-1', flat='flat', @click.native='C.trigger.confirmDevelopmentComponentDelete()')
                | Confirm

    v-tabs.construction-tabs(v-model='C.state.tab.development.active', :is-booted='true', slider-color='primary')
      v-tab.hide(:href='`#development-base`', :ripple="false")
        | Base
      v-tab.hide(v-for='(component, componentIndex) in C.form.selected.invention.container_section.c_development.components', :key='componentIndex' :href='`#development-${componentIndex}`', :ripple="false")
        | {{ component.type }}
      v-tabs-items(v-model='C.state.tab.development.item')

        v-tab-item.construction.pt-0(:id='`development-base`')
          .invention__title(v-if='C.state.isEditable')
            .title
              | Development

          section.invention__section
            | Add as many steps (milestones) needed to develop the proof of concept or next stage prototype of the invention?

        v-tab-item.construction.pt-0(v-for='(component, componentIndex) in C.form.selected.invention.container_section.c_development.components', :key='componentIndex', :id='`development-${componentIndex}`')
          section
            .invention__title.invention__title--actions
              v-layout(row, no-wrap, align-end)
                v-flex
                  .title.text--capitalize.pb-2
                    | {{ component.type }}
                .d-inline-flex
                  v-tooltip(bottom)
                    v-btn(@click='C.form.trigger.deleteDevelopmentComponent(component)', :flat='!component.delete', :outline='!component.delete', :fab='component.delete', :small='component.delete', :dark='component.delete', icon, color='secondary', slot="activator", v-if='C.state.isEditable')
                      v-icon(small) delete
                    span Delete
                  completion-check(section-id='c_development', :component-id='component.id', :section-item='component', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='component.id && component.items.key_points.content && component.items.resources_needed.content && component.items.deliverables.content && component.items.measure_of_success.content && component.items.key_risks.content && component.items.suggested_approach.content')
          section(v-if='C.state.isEditable')
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Short title for milestone
            v-text-field.mb-3(v-model='component.type', @input='C.form.event.typeAutoSave()', label='Title', :counter='100', solo)
          section.invention__section
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Key Points: What are the most important aspects of this development step
                  v-icon.ml-2(v-if='component.items.key_points.content && CR.show.unreleased', small, color='primary')
                    | check_circle
            froala(v-model='component.items.key_points.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='component.items.key_points.content', v-if='!C.state.isEditable')
          section.invention__section
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Resources Needed: Describe facilities, funding requirements, time and/or other key resources that would be needed to deliver the milestone.
                  v-icon.ml-2(v-if='component.items.resources_needed.content && CR.show.unreleased', small, color='primary')
                    | check_circle
            froala(v-model='component.items.resources_needed.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='component.items.resources_needed.content', v-if='!C.state.isEditable')
          section.invention__section
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Deliverables: What is produced at the end of the development step.
                  v-icon.ml-2(v-if='component.items.deliverables.content && CR.show.unreleased', small, color='primary')
                    | check_circle
            froala(v-model='component.items.deliverables.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='component.items.deliverables.content', v-if='!C.state.isEditable')
          section.invention__section
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Measure of Success: What are the metrics to know we have achieved the goal at the end of this development step?
                  v-icon.ml-2(v-if='component.items.measure_of_success.content && CR.show.unreleased', small, color='primary')
                    | check_circle
            froala(v-model='component.items.measure_of_success.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='component.items.measure_of_success.content', v-if='!C.state.isEditable')
          section.invention__section
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Key Risks: What can be foreseen as major areas of risk to the success of this development step and what can be done to migrate them?
                  v-icon.ml-2(v-if='component.items.key_risks.content && CR.show.unreleased', small, color='primary')
                    | check_circle
            froala(v-model='component.items.key_risks.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='component.items.key_risks.content', v-if='!C.state.isEditable')
          section.invention__section
            v-layout(row, align-center)
              v-flex
                .subheading.mb-0
                  | Suggested Approach: What materials and methods are required for this milestone?
                  v-icon.ml-2(v-if='component.items.suggested_approach.content && CR.show.unreleased', small, color='primary')
                    | check_circle
            froala(v-model='component.items.suggested_approach.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
            div(v-html='component.items.suggested_approach.content', v-if='!C.state.isEditable')

    section(v-if='C.state.isEditable')
      v-container.pa-0(fluid, style='margin-left: -1.75em')

        v-layout(row, wrap, align-center)
          v-flex(xs4)
            v-btn(flat, color='primary', @click='C.form.trigger.addDevelopmentComponent()')
              v-icon.mr-2 add_circle
              | Add{{ C.form.selected.invention.container_section.c_development.components.length === 0 ? "" : " Another" }} Step





  div(v-if='C.state.container[6].active')
    .invention__title
      .title Specific Questions

    section.invention__section#specificquestions-specificquestions
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | Add Question & Answer for all questions asked in the Opportunity
        completion-check(section-id='specificquestions', :section-item='C.form.selected.invention.container_section.specificquestions', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.specificquestions.content')
      froala(v-model='C.form.selected.invention.container_section.specificquestions.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.specificquestions.content', v-if='!C.state.isEditable')





  div(v-if='C.state.container[7].active')
    .invention__title
      .title References

    section.invention__section#references-references
      v-layout(row, align-center)
        v-flex
          .subheading.mb-0
            | List of relevant references (URLs).
        completion-check(section-id='references', :section-item='C.form.selected.invention.container_section.references', :save-callback='C.trigger.openChecklist', :is-editable='C.state.isEditable', v-if='C.form.selected.invention.container_section.references.content')
      froala(v-model='C.form.selected.invention.container_section.references.content', :config='C.form.config.froala.invention.description', v-if='C.state.isEditable')
      div(v-html='C.form.selected.invention.container_section.references.content', v-if='!C.state.isEditable')





  v-navigation-drawer.editor__rightpanel(app, right, permanent, floating, fixed, clipped , width="300")
    v-tabs.mt-3(v-model='C.state.tab.inventionNotesSidepanel.active', :is-booted='true', slider-color='primary')
      v-tab(href='#tab-comments', :ripple="false")
        | Comments
      v-tab(href='#tab-scratchpad', :ripple="false")
        | Scratchpad
      v-tab(href='#tab-keywords', :ripple="false")
        | Search

      v-tabs-items(v-model='C.state.tab.inventionNotesSidepanel.item')
        v-tab-item(:key='1', :id='`tab-comments`')
          v-layout(row, wrap)
            v-flex(xs12, v-for='comment in C.form.selected.comments.$list', :key='comment.id')
              v-card.card--borderless.py-3(flat)
                v-layout(row, nowrap, justify-space-between)
                  v-flex
                    v-layout.mb-2(row, nowrap, justify-space-between, align-center)
                      v-flex
                        v-layout(row, nowrap, align-center)
                          v-tooltip(right)
                            avatar(slot="activator", :size='32', :username='comment.user_name ? comment.user_name : "?"')
                            span {{ comment.user_name }}
                      v-flex.text-xs-right
                        .grey--text
                          | {{ comment.created_time | moment("h:mm A, MMM D, YYYY") }}
                    p
                      | {{ comment.content }}
              v-divider

          v-flex(xs12)
            v-card.card--borderless.py-0(flat)
              v-layout(row, nowrap, justify-space-between)
                v-flex
                  v-text-field(v-model='C.form.selected.comments.content', textarea, label='Comment', :counter='500', auto-grow, rows='2')

              v-layout(row, nowrap, justify-end)
                  v-btn.ma-0(color='secondary', @click='C.form.trigger.addComment')
                    | Send

        v-tab-item(:key='2', :id='`tab-scratchpad`')
          .text-xs-right
          v-layout(row, wrap)
            v-flex(xs12)
              froala(v-model='C.form.selected.scratchpad', :config='C.form.config.froala.invention.scratchpad', v-if='C.state.isEditable')
              div(v-html='C.form.selected.scratchpad', v-if='!C.state.isEditable')
        v-tab-item(:key='3', :id='`tab-keywords`')
          div
            v-flex
              .subheading.mb-0
                | Keywords
            froala(v-model='C.form.selected.invention.keywords', :config='C.form.config.froala.invention.scratchpad', v-if='C.state.isEditable')
            div(v-html='C.form.selected.invention.keywords', v-if='!C.state.isEditable')

          v-layout(row, wrap, v-if='C.state.isEditable')
            v-flex
              .subheading.mb-0
                | Searches
            v-flex(xs12)
              v-text-field(v-model='C.form.selected.invention.$search.title', :rules='C.form.validation.rules.invention.search.title', :maxlength='1000', label='Add a Search', multi-line, auto-grow, rows="1", prepend-icon="search", v-on:focus='C.form.state.active.$search = true')

          transition(name='expand', v-if='C.state.isEditable')
            .mb-3(v-if="C.form.state.active.$search")
              v-flex(xs12)
                v-text-field(v-model='C.form.selected.invention.$search.url', :rules='C.form.validation.rules.invention.search.general', :maxlength='1000', label='Paste URL', multi-line, auto-grow, rows="1", prepend-icon="insert_link")
              v-flex(xs12)
                v-text-field(v-model='C.form.selected.invention.$search.note', :rules='C.form.validation.rules.invention.search.general', :maxlength='1000', label='Search Note', multi-line, auto-grow, rows="1", prepend-icon="note")
              v-flex(style="padding-left: 33px;")
                v-btn(color="primary", v-on:click='C.form.trigger.addSearchItem()') Save Search
                v-btn(v-on:click='C.form.state.active.$search = false') Cancel
          v-layout.mb-3(row, nowrap, align-start, v-for='(searchItem, searchItemIndex) in C.form.selected.invention.search', :key='searchItemIndex')
            v-icon youtube_searched_for
            v-flex.pl-3
              p.mb-0(v-if='!searchItem.url')
                | {{ searchItem.title }}
              a(:href='searchItem.url', target='_blank', v-if='searchItem.url')
                | {{ searchItem.title }}
              p.mb-0.grey--text {{ searchItem.note }}
            .search-list__close(v-if='C.state.isEditable')
              v-btn(@click='C.form.trigger.removeSearchItem(searchItem, searchItemIndex)', flat, icon, color='secondary', v-if='!searchItem.remove')
                v-icon close
              v-btn(@click='C.form.trigger.removeSearchItem(searchItem, searchItemIndex)', fab, small, icon, color='secondary', dark, v-if='searchItem.remove')
                v-icon close

          div
            v-flex
              .subheading.mb-0
                | Results
            froala(v-model='C.form.selected.invention.search_results', :config='C.form.config.froala.invention.scratchpad', v-if='C.state.isEditable')
            div(v-html='C.form.selected.invention.search_results', v-if='!C.state.isEditable')

</template>

<script>
  import Vue from 'vue'

  import BasicTooltip from './BasicTooltip'
  import CompletionCheck from './CompletionCheck'

  import globalSettings from '../../assets/global-settings.js'
  import tools from '../../assets/tools.js'

  import axios from '../../../node_modules/axios/dist/axios.js'
  import _ from '../../../node_modules/underscore/underscore-min.js'
  import Avatar from 'vue-avatar'

  function froalaContentChangeAutosave (component, targetAutosave) {
    if (component.C.state.initialized) {
      clearTimeout(component.C.timer.autoSave)

      component.C.state.autoSave[targetAutosave] = true

      component.C.timer.autoSave = setTimeout(function () {
        function autoSaveContainers (callback) {
          component.C.form.trigger.updateAllContainerSections(function (responseData) {
            var containerSectionItem = (responseData && responseData.data && responseData.data.invention && responseData.data.invention.container_section) || {}
            containerSectionItem.c_comparativeadvantages = containerSectionItem.c_comparativeadvantages || {
              components: []
            }
            containerSectionItem.c_construction = containerSectionItem.c_construction || {
              components: []
            }
            containerSectionItem.c_development = containerSectionItem.c_development || {
              components: []
            }

            for (var i = 0; i < containerSectionItem.c_comparativeadvantages.components.length; i++) {
              var componentItem = containerSectionItem.c_comparativeadvantages.components[i]

              if (component.C.form.selected.invention.container_section.c_comparativeadvantages.components[i] && !component.C.form.selected.invention.container_section.c_comparativeadvantages.components[i].id) {
                component.C.form.selected.invention.container_section.c_comparativeadvantages.components[i].id = componentItem.id
              }
            }

            for (i = 0; i < containerSectionItem.c_construction.components.length; i++) {
              componentItem = containerSectionItem.c_construction.components[i]

              if (component.C.form.selected.invention.container_section.c_construction.components[i] && !component.C.form.selected.invention.container_section.c_construction.components[i].id) {
                component.C.form.selected.invention.container_section.c_construction.components[i].id = componentItem.id
              }
            }

            for (i = 0; i < containerSectionItem.c_development.components.length; i++) {
              componentItem = containerSectionItem.c_development.components[i]

              if (component.C.form.selected.invention.container_section.c_development.components[i] && !component.C.form.selected.invention.container_section.c_development.components[i].id) {
                component.C.form.selected.invention.container_section.c_development.components[i].id = componentItem.id
              }
            }

            callback()
          }, true)
        }
        function autoSaveScratchpad (callback) {
          component.C.form.trigger.saveSidePanelItems(function (response) {
            var inventionDataItem = (response && response.data && response.data.invention) || {}

            component.C.form.selected.invention.search = inventionDataItem.searches

            callback()
          }, true)
        }

        function autoSaveComplete () {
          component.C.form.state.recentSaveActive = true

          clearTimeout(component.C.timer.saveIndicator)

          component.C.timer.saveIndicator = setTimeout(function () {
            component.C.form.state.recentSaveActive = false
          }, 5000)

          component.C.state.autoSave.containers = false
          component.C.state.autoSave.scratchpad = false
        }

        if (component.C.state.autoSave.containers && component.C.state.autoSave.scratchpad) {
          autoSaveContainers(function () {
            autoSaveScratchpad(function () {
              autoSaveComplete()
            })
          })
        } else if (component.C.state.autoSave.containers) {
          autoSaveContainers(function () {
            autoSaveComplete()
          })
        } else if (component.C.state.autoSave.scratchpad) {
          autoSaveScratchpad(function () {
            autoSaveComplete()
          })
        }
      }, 2000)
    }
  }

  export default {
    components: {
      Avatar,
      'basic-tooltip': BasicTooltip,
      'completion-check': CompletionCheck
    },
    data () {
      return {
        CR: {
          authorization: globalSettings.authorization,
          show: globalSettings.show,
          trigger: {
            signOut: () => {
              tools.signOut({
                success: () => {
                  this.$router.push({
                    name: 'MagicSignIn'
                  })
                }
              })
            }
          }
        },
        C: {
          config: {
            containerSections: []
          },
          timer: {
            autoSave: null,
            saveIndicator: null
          },
          state: {
            initialized: false,
            isEditable: false,
            autoSave: {
              containers: false,
              scratchpad: false
            },
            tab: {
              checklist: {
                active: null,
                item: null
              },
              inventionNotesSidepanel: {
                active: null,
                item: 'tab-commments'
              },
              construction: {
                active: null,
                item: null
              },
              comparativeadvantages: {
                active: null,
                item: null
              },
              development: {
                active: null,
                item: null
              }
            },
            panel: {
              settings: false
            },
            dialog: {
              confirmComparativeadvantagesComponentDelete: {
                active: false
              },
              confirmConstructionComponentDelete: {
                active: false
              },
              confirmDevelopmentComponentDelete: {
                active: false
              }
            },
            container: [
              {
                title: 'Solution',
                phaseThreshold: 2,
                active: true,
                items: [
                  {
                    key: 'summary',
                    title: 'Summary',
                    href: '#solution-summary',
                    includeAPI: true
                  },
                  {
                    key: 'draw',
                    title: 'Draw',
                    href: '#solution-draw',
                    includeAPI: true
                  },
                  {
                    key: 'significance',
                    title: 'Significance',
                    href: '#solution-significance',
                    includeAPI: true
                  }
                ]
              },
              {
                title: 'Problem',
                phaseThreshold: 2,
                inactive: true,
                items: [
                  {
                    key: 'problem_summary',
                    title: 'Summary',
                    href: '#problem-summary',
                    includeAPI: true
                  },
                  {
                    key: 'gap',
                    title: 'Gap',
                    href: '#problem-gap',
                    includeAPI: true
                  },
                  {
                    key: 'problem_significance',
                    title: 'Significance',
                    href: '#problem-significance',
                    includeAPI: true
                  }
                ]
              },
              {
                title: 'Comparative Advantages',
                phaseThreshold: 3,
                inactive: true,
                componentContainerKey: 'comparativeadvantages',
                items: [{
                  title: 'General Info',
                  href: '#comparativeadvantages-general',
                  includeAPI: false,
                  notComponent: true,
                  subAPIitems: [{
                    key: 'landscape',
                    title: 'Landscape',
                    href: '#comparativeadvantages_landscape',
                    includeAPI: true
                  }, {
                    key: 'comparativeadvantages_innovativeaspects',
                    title: 'Innovative Aspects'
                  }, {
                    key: 'comparativeadvantages_advantagessummary',
                    title: 'Summary'
                  }, {
                    key: 'comparativeadvantages_relevantbackground',
                    title: 'Relevant Background'
                  }]
                }],
                navSelectTrigger: () => {
                  var component = this

                  component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-base'
                }
              },
              {
                title: 'Construction',
                phaseThreshold: 3,
                inactive: true,
                componentContainerKey: 'construction',
                items: [{
                  title: 'General Info',
                  href: '#construction-general',
                  includeAPI: false,
                  notComponent: true,
                  subAPIitems: [{
                    key: 'construction_howused',
                    title: 'How is it used?'
                  }, {
                    key: 'construction_prototype',
                    title: 'Prototype (Optional)',
                    exemptRequired: true
                  }]
                }]
              },
              {
                title: 'Economics',
                phaseThreshold: 3,
                inactive: true,
                items: [
                  {
                    key: 'economics_need',
                    title: 'Market Need',
                    href: '#economics-need',
                    includeAPI: true
                  },
                  {
                    key: 'economics_enduser',
                    title: 'End User',
                    href: '#economics-enduser',
                    includeAPI: true
                  },
                  {
                    key: 'economics_keyresources',
                    title: 'Key Resources',
                    href: '#economics-keyresources',
                    includeAPI: true
                  },
                  {
                    key: 'economics_capitalexpenditure',
                    title: 'Expenditure Requirements',
                    href: '#economics-capitalexpenditure',
                    includeAPI: true
                  },
                  {
                    key: 'economics_feasiblyeconomical',
                    title: 'Economical Feasibility',
                    href: '#economics-feasiblyeconomical',
                    includeAPI: true
                  },
                  {
                    key: 'economics_whomake',
                    title: 'Who',
                    href: '#economics-whomake',
                    includeAPI: true
                  },
                  {
                    key: 'economics_howmakemoney',
                    title: 'Make Money',
                    href: '#economics-howmakemoney',
                    includeAPI: true
                  },
                  {
                    key: 'economics_howdelivered',
                    title: 'Delivery',
                    href: '#economics-howdelivered',
                    includeAPI: true
                  },
                  {
                    key: 'economics_economicburden',
                    title: 'Economic Burden',
                    href: '#economics-economicburden',
                    includeAPI: true
                  },
                  {
                    key: 'economics_currentsolutioncosts',
                    title: 'Current Solution Costs',
                    href: '#economics-currentsolutioncosts',
                    includeAPI: true
                  },
                  {
                    key: 'economics_consumercosts',
                    title: 'Customer Costs',
                    href: '#economics-consumercosts',
                    includeAPI: true
                  }
                ]
              },
              {
                title: 'Development',
                phaseThreshold: 3,
                inactive: true,
                componentContainerKey: 'development',
                items: []
              },
              {
                title: 'Specific Questions',
                phaseThreshold: 3,
                inactive: true,
                hideItemsList: true,
                items: [
                  {
                    key: 'specificquestions',
                    title: '',
                    href: '#specificquestions-specificquestions',
                    includeAPI: true
                  }
                ]
              },
              {
                title: 'References',
                phaseThreshold: 3,
                inactive: true,
                hideItemsList: true,
                items: [
                  {
                    key: 'references',
                    title: '',
                    href: '#references-references',
                    includeAPI: true
                  }
                ]
              }
            ]
          },
          data: {
            invention: {}
          },
          form: {
            config: {
              froala: {
                invention: {
                  description: tools.setupFroalaConfig({
                    events: {
                      'contentChanged': () => {
                        var component = this

                        froalaContentChangeAutosave(component, 'containers')
                      }
                    }
                  }),
                  scratchpad: tools.setupFroalaConfig({
                    events: {
                      'contentChanged': () => {
                        var component = this

                        froalaContentChangeAutosave(component, 'scratchpad')
                      }
                    }
                  }),
                  container_section: {
                    draw: {
                      content: tools.setupFroalaConfig({
                        placeholderText: '',
                        pluginsEnabled: ['image'],
                        toolbarButtons: [
                          'insertImage'
                        ],
                        events: {
                          'contentChanged': () => {
                            var component = this

                            froalaContentChangeAutosave(component, 'containers')
                          }
                        }
                      })
                    }
                  }
                }
              }
            },
            state: {
              active: {
                $search: false
              },
              dialog: {
                checklist: false
              },
              recentSaveActive: false
            },
            list: {
              constructionComponentOptions: [{
                label: 'Material',
                key: 'material'
              }, {
                label: 'Sub-Component',
                key: 'sub-component'
              }, {
                label: 'Component',
                key: 'component'
              }, {
                label: 'Device',
                key: 'device'
              }, {
                label: 'System',
                key: 'system'
              }, {
                label: 'Service',
                key: 'service'
              }],
              collaboratorAccessOptions: {
                items: [{
                  label: 'Co-inventor',
                  value: 1
                }, {
                  label: 'Mentor/Expert',
                  value: 2
                }, {
                  label: 'Commenter',
                  value: 3
                }],
                dictionary: {
                  '1': 'Co-inventor',
                  '2': 'Mentor/Expert',
                  '3': 'Commenter'
                }
              },
              bulkDefaultAccessOptions: [{
                label: 'Anyone in my organization can comment',
                value: 'anyone-organization'
              }, {
                label: 'Only collaborators in my organization can comment',
                value: 'only-inventors'
              }],
              opportunities: []
            },
            validation: {
              rules: {
                invention: {
                  search: {
                    title: [
                      (v) => !!v || 'Title is required',
                      (v) => v.length < 1000 || 'You have reached the maximum limit of 1,000 characters.'
                    ],
                    general: [
                      (v) => v.length < 1000 || 'You have reached the maximum limit of 1,000 characters.'
                    ]
                  }
                }
              }
            },
            selected: {
              invention_id: null,
              invention: {
                title: '',
                description: '',
                search_list: '',
                keywords: '',
                search_results: '',
                action: '',
                action_note: '',
                search: [],
                $search: {
                  title: '',
                  url: '',
                  note: '',
                  tag: ''
                },
                uploaded_filename: '',
                invention_opportunity_id: null,
                organization_id: null,
                bulk_read_access: null,
                container_section: {}
              },
              $collaborator: {
                $item: null,
                access: null
              },
              scratchpad: '',
              co_inventors: [],
              upload: null,
              comments: {
                $list: [],
                content: ''
              }
            },
            event: {
              typeAutoSave: () => {
                var component = this

                froalaContentChangeAutosave(component, 'containers')
              }
            },
            trigger: {
              addSearchItem: (searchItem) => {
                var component = this

                component.C.form.selected.invention.search.push({
                  title: component.C.form.selected.invention.$search.title,
                  url: component.C.form.selected.invention.$search.url,
                  note: component.C.form.selected.invention.$search.note,
                  tag: component.C.form.selected.invention.$search.tag
                })

                component.C.form.selected.invention.$search.title = ''
                component.C.form.selected.invention.$search.url = ''
                component.C.form.selected.invention.$search.note = ''
                component.C.form.selected.invention.$search.tag = ''

                component.C.form.state.active.$search = false

                component.C.trigger.openChecklist()
                froalaContentChangeAutosave(component, 'scratchpad')
              },
              removeSearchItem: (searchItem, searchItemIndex) => {
                var component = this

                if (!searchItem.id) {
                  component.C.form.selected.invention.search.splice(searchItemIndex, 1)
                } else {
                  Vue.set(searchItem, 'remove', !searchItem.remove)
                  froalaContentChangeAutosave(component, 'scratchpad')
                }
              },
              addCollaboratorItem: () => {
                var component = this

                if (component.C.form.selected.$collaborator.$item && component.C.form.selected.$collaborator.access) {
                  component.C.form.selected.co_inventors.push({
                    $isNew: true,
                    $name: component.C.form.selected.$collaborator.$item.fullname,
                    user_id: component.C.form.selected.$collaborator.$item.id,
                    access: component.C.form.selected.$collaborator.access,
                    remove: false
                  })

                  component.C.form.selected.$collaborator.$item = null
                  component.C.form.selected.$collaborator.access = null
                }
              },
              removeCollaboratorItem: (collaboratorItem, collaboratorIndex) => {
                var component = this

                if (collaboratorItem.$isNew) {
                  component.C.form.selected.co_inventors.splice(collaboratorIndex, 1)
                } else {
                  Vue.set(collaboratorItem, 'remove', !collaboratorItem.remove)
                }
              },
              selectContainerItem: (targetContainer) => {
                if (targetContainer.navSelectTrigger) {
                  targetContainer.navSelectTrigger()
                }
              },
              selectContainerSectionItem: (targetData) => {
                targetData = targetData || {}
                var item = targetData.item || {}
                var subItem = targetData.subItem || {}
                var targetIndex = targetData.index

                var component = this

                if (item.componentContainerKey) {
                  if (subItem.useByIndex) {
                    component.C.state.tab[item.componentContainerKey].active = `${item.componentContainerKey}-${targetIndex}`
                  } else {
                    component.C.state.tab[item.componentContainerKey].active = `${subItem.href}`.substr(1)
                  }
                }
              },
              updateAllContainerSections: (callback, negateDeletion) => {
                var component = this
                callback = callback || _.noop

                var submitItem = {
                  invention_id: parseInt(component.$route.params.id)
                }

                for (var i = 0; i < component.C.config.containerSections.length; i++) {
                  submitItem[component.C.config.containerSections[i]] = component.C.form.selected.invention.container_section[component.C.config.containerSections[i]].content
                }

                submitItem.c_comparativeadvantages = []
                submitItem.c_constructions = []
                submitItem.c_developments = []

                for (i = 0; i < component.C.form.selected.invention.container_section.c_comparativeadvantages.components.length; i++) {
                  var currentComponent = component.C.form.selected.invention.container_section.c_comparativeadvantages.components[i]

                  submitItem.c_comparativeadvantages.push({
                    id: currentComponent.id,
                    c_type: currentComponent.type,
                    delete: (currentComponent.delete || false) && !negateDeletion,
                    competing_howworks: currentComponent.items.competing_howworks.content,
                    shortcomings: currentComponent.items.shortcomings.content,
                    howovercomes_shortcomings: currentComponent.items.howovercomes_shortcomings.content
                  })
                }

                for (i = 0; i < component.C.form.selected.invention.container_section.c_construction.components.length; i++) {
                  currentComponent = component.C.form.selected.invention.container_section.c_construction.components[i]

                  submitItem.c_constructions.push({
                    id: currentComponent.id,
                    c_type: currentComponent.type,
                    delete: (currentComponent.delete || false) && !negateDeletion,
                    ideal_example: currentComponent.items.ideal_example.content,
                    properties: currentComponent.items.properties.content,
                    how_made: currentComponent.items.how_made.content,
                    innovative_aspects: currentComponent.items.innovative_aspects.content,
                    why_hasnt_done_before: currentComponent.items.why_hasnt_done_before.content
                  })
                }

                for (i = 0; i < component.C.form.selected.invention.container_section.c_development.components.length; i++) {
                  currentComponent = component.C.form.selected.invention.container_section.c_development.components[i]

                  submitItem.c_developments.push({
                    id: currentComponent.id,
                    c_type: currentComponent.type,
                    delete: (currentComponent.delete || false) && !negateDeletion,
                    key_points: currentComponent.items.key_points.content,
                    resources_needed: currentComponent.items.resources_needed.content,
                    deliverables: currentComponent.items.deliverables.content,
                    measure_of_success: currentComponent.items.measure_of_success.content,
                    key_risks: currentComponent.items.key_risks.content,
                    suggested_approach: currentComponent.items.suggested_approach.content
                  })
                }

                axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/container_sections/update`, submitItem)
                  .then(function (response) {
                    console.info('Update Container Sections Results: ', response.data)

                    callback(response.data)
                  })
                  .catch(function (errorResponse) {
                    tools.alert({
                      type: 'error',
                      errorResponse: errorResponse
                    })
                  })
              },
              addComparativeadvantagesComponent: () => {
                var component = this

                var targetComponentType = `Current Technology ${component.C.form.selected.invention.container_section.c_comparativeadvantages.components.length + 1}`

                component.C.form.selected.invention.container_section.c_comparativeadvantages.components.push({
                  type: targetComponentType,
                  items: {
                    competing_howworks: {
                      content: ''
                    },
                    shortcomings: {
                      content: ''
                    },
                    howovercomes_shortcomings: {
                      content: ''
                    }
                  }
                })

                var comparativeadvantagesComponentIndex = component.C.form.selected.invention.container_section.c_comparativeadvantages.components.length - 1

                component.C.state.container[2].items.splice(component.C.state.container[2].items.length - 1, 0, {
                  key: targetComponentType,
                  title: targetComponentType, // ### TEMPORARY - Need label
                  href: `#comparativeadvantages-${comparativeadvantagesComponentIndex}`,
                  useByIndex: true
                })

                component.C.state.tab.comparativeadvantages.active = `comparativeadvantages-${comparativeadvantagesComponentIndex}`

                component.C.trigger.openChecklist()
                component.C.trigger.scrollToTop()
              },
              addConstructionComponent: (targetComponentType) => {
                var component = this

                component.C.form.selected.invention.container_section.c_construction.components.push({
                  type: targetComponentType,
                  items: {
                    ideal_example: {
                      content: ''
                    },
                    properties: {
                      content: ''
                    },
                    how_made: {
                      content: ''
                    },
                    innovative_aspects: {
                      content: ''
                    },
                    why_hasnt_done_before: {
                      content: ''
                    }
                  }
                })

                var constructionComponentIndex = component.C.form.selected.invention.container_section.c_construction.components.length - 1

                component.C.state.container[3].items.splice(component.C.state.container[3].items.length - 1, 0, {
                  key: targetComponentType,
                  title: targetComponentType, // ### TEMPORARY - Need label
                  href: `#construction-${constructionComponentIndex}`,
                  useByIndex: true
                })

                component.C.state.tab.construction.active = `construction-${constructionComponentIndex}`

                component.C.trigger.openChecklist()
                component.C.trigger.scrollToTop()
              },
              addDevelopmentComponent: () => {
                var component = this

                var targetComponentType = `Milestone ${component.C.form.selected.invention.container_section.c_development.components.length + 1}`

                component.C.form.selected.invention.container_section.c_development.components.push({
                  type: targetComponentType,
                  items: {
                    key_points: {
                      content: ''
                    },
                    resources_needed: {
                      content: ''
                    },
                    deliverables: {
                      content: ''
                    },
                    measure_of_success: {
                      content: ''
                    },
                    key_risks: {
                      content: ''
                    },
                    suggested_approach: {
                      content: ''
                    }
                  }
                })

                var developmentComponentIndex = component.C.form.selected.invention.container_section.c_development.components.length - 1

                component.C.state.container[5].items.push({
                  key: targetComponentType,
                  title: targetComponentType, // ### TEMPORARY - Need label
                  href: `#development-${developmentComponentIndex}`,
                  useByIndex: true
                })

                component.C.state.tab.development.active = `development-${developmentComponentIndex}`

                component.C.trigger.openChecklist()
                component.C.trigger.scrollToTop()
              },
              deleteComparativeadvantagesComponent: (targetComponent, confirmedDeletion) => {
                var component = this

                var targetComponentIndex = component.C.form.selected.invention.container_section.c_comparativeadvantages.components.indexOf(targetComponent)

                if (!_.isUndefined(targetComponent.id)) {
                  component.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = true
                  component.C.trigger.confirmComparativeadvantagesComponentDelete = function () {
                    Vue.set(targetComponent, 'delete', true)

                    if (component.C.state.tab.comparativeadvantages.active === `comparativeadvantages-${targetComponentIndex}`) {
                      component.C.state.tab.comparativeadvantages.active = `comparativeadvantages-${targetComponentIndex - 1}`
                    }
                    component.C.form.trigger.saveAll(false)

                    component.C.trigger.confirmComparativeadvantagesComponentDelete = _.noop
                    component.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = false
                  }

                  if (confirmedDeletion) {
                    component.C.trigger.confirmComparativeadvantagesComponentDelete()
                  }
                } else {
                  if (!confirmedDeletion && (targetComponent.items.competing_howworks.content || targetComponent.items.shortcomings.content || targetComponent.items.howovercomes_shortcomings.content)) {
                    component.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = true
                    component.C.trigger.confirmComparativeadvantagesComponentDelete = function () {
                      component.C.form.trigger.deleteComparativeadvantagesComponent(targetComponent, true)
                    }
                  } else {
                    if (component.C.state.tab.comparativeadvantages.active === `comparativeadvantages-${targetComponentIndex}`) {
                      component.C.state.tab.comparativeadvantages.active = `comparativeadvantages-${targetComponentIndex - 1}`
                    }

                    component.C.state.container[2].items.splice(targetComponentIndex, 1)
                    component.C.form.selected.invention.container_section.c_comparativeadvantages.components.splice(targetComponentIndex, 1)

                    component.C.trigger.confirmComparativeadvantagesComponentDelete = _.noop
                    component.C.state.dialog.confirmComparativeadvantagesComponentDelete.active = false

                    component.C.trigger.openChecklist()
                  }
                }
              },
              deleteConstructionComponent: (targetComponent, confirmedDeletion) => {
                var component = this

                var targetComponentIndex = component.C.form.selected.invention.container_section.c_construction.components.indexOf(targetComponent)

                if (!_.isUndefined(targetComponent.id)) {
                  component.C.state.dialog.confirmConstructionComponentDelete.active = true
                  component.C.trigger.confirmConstructionComponentDelete = function () {
                    Vue.set(targetComponent, 'delete', true)

                    if (component.C.state.tab.construction.active === `construction-${targetComponentIndex}`) {
                      component.C.state.tab.construction.active = `construction-${targetComponentIndex - 1}`
                    }
                    component.C.form.trigger.saveAll(false)

                    component.C.trigger.confirmConstructionComponentDelete = _.noop
                    component.C.state.dialog.confirmConstructionComponentDelete.active = false
                  }

                  if (confirmedDeletion) {
                    component.C.trigger.confirmConstructionComponentDelete()
                  }
                } else {
                  if (!confirmedDeletion && (targetComponent.items.how_made.content || targetComponent.items.ideal_example.content || targetComponent.items.innovative_aspects.content || targetComponent.items.properties.content || targetComponent.items.why_hasnt_done_before.content)) {
                    component.C.state.dialog.confirmConstructionComponentDelete.active = true
                    component.C.trigger.confirmConstructionComponentDelete = function () {
                      component.C.form.trigger.deleteConstructionComponent(targetComponent, true)
                    }
                  } else {
                    if (component.C.state.tab.construction.active === `construction-${targetComponentIndex}`) {
                      component.C.state.tab.construction.active = `construction-${targetComponentIndex - 1}`
                    }

                    component.C.state.container[3].items.splice(targetComponentIndex, 1)
                    component.C.form.selected.invention.container_section.c_construction.components.splice(targetComponentIndex, 1)

                    component.C.trigger.confirmConstructionComponentDelete = _.noop
                    component.C.state.dialog.confirmConstructionComponentDelete.active = false

                    component.C.trigger.openChecklist()
                  }
                }
              },
              deleteDevelopmentComponent: (targetComponent, confirmedDeletion) => {
                var component = this

                var targetComponentIndex = component.C.form.selected.invention.container_section.c_development.components.indexOf(targetComponent)

                if (!_.isUndefined(targetComponent.id)) {
                  component.C.state.dialog.confirmDevelopmentComponentDelete.active = true
                  component.C.trigger.confirmDevelopmentComponentDelete = function () {
                    Vue.set(targetComponent, 'delete', true)

                    if (component.C.state.tab.development.active === `development-${targetComponentIndex}`) {
                      component.C.state.tab.development.active = `development-${targetComponentIndex - 1}`
                    }
                    component.C.form.trigger.saveAll(false)

                    component.C.trigger.confirmDevelopmentComponentDelete = _.noop
                    component.C.state.dialog.confirmDevelopmentComponentDelete.active = false
                  }

                  if (confirmedDeletion) {
                    component.C.trigger.confirmDevelopmentComponentDelete()
                  }
                } else {
                  if (!confirmedDeletion && (targetComponent.items.key_points.content || targetComponent.items.resources_needed.content || targetComponent.items.deliverables.content || targetComponent.items.measure_of_success.content || targetComponent.items.key_risks.content || targetComponent.items.suggested_approach.content)) {
                    component.C.state.dialog.confirmDevelopmentComponentDelete.active = true
                    component.C.trigger.confirmDevelopmentComponentDelete = function () {
                      component.C.form.trigger.deleteDevelopmentComponent(targetComponent, true)
                    }
                  } else {
                    if (component.C.state.tab.development.active === `development-${targetComponentIndex}`) {
                      component.C.state.tab.development.active = `development-${targetComponentIndex - 1}`
                    }

                    component.C.state.container[5].items.splice(targetComponentIndex, 1)
                    component.C.form.selected.invention.container_section.c_development.components.splice(targetComponentIndex, 1)

                    component.C.trigger.confirmDevelopmentComponentDelete = _.noop
                    component.C.state.dialog.confirmDevelopmentComponentDelete.active = false

                    component.C.trigger.openChecklist()
                  }
                }
              },
              saveSidePanelItems: (callback, skipClose) => {
                var component = this
                callback = callback || _.noop

                var submitBlob = new FormData()
                submitBlob.append('invention[title]', component.C.form.selected.invention.title)
                submitBlob.append('scratchpad', component.C.form.selected.scratchpad)
                submitBlob.append('invention[keywords]', component.C.form.selected.invention.keywords)
                submitBlob.append('invention[search_results]', component.C.form.selected.invention.search_results)

                submitBlob.append('invention[organization_id]', component.C.form.selected.invention.organization_id)

                submitBlob.append('invention_id', component.C.form.selected.invention_id)

                for (i = 0; i < component.C.form.selected.invention.search.length; i++) {
                  var targetSearchItem = component.C.form.selected.invention.search[i]

                  submitBlob.append('searches[][id]', (targetSearchItem.id || null))
                  submitBlob.append('searches[][title]', targetSearchItem.title)
                  submitBlob.append('searches[][url]', targetSearchItem.url)
                  submitBlob.append('searches[][note]', targetSearchItem.note)
                  submitBlob.append('searches[][tag]', targetSearchItem.tag)
                  submitBlob.append('searches[][remove]', (targetSearchItem.remove || false))
                }

                if (!skipClose) {
                  if (component.C.form.selected.invention.invention_opportunity_id === '$other') {
                    submitBlob.append('invention[invention_opportunity_id]', 'other')
                  } else if (component.C.form.selected.invention.invention_opportunity_id) {
                    submitBlob.append('invention[invention_opportunity_id]', component.C.form.selected.invention.invention_opportunity_id)
                  }

                  for (var i = 0; i < component.C.form.selected.co_inventors.length; i++) {
                    submitBlob.append('co_inventors[][user_id]', component.C.form.selected.co_inventors[i].user_id)
                    submitBlob.append('co_inventors[][access]', component.C.form.selected.co_inventors[i].access)
                    submitBlob.append('co_inventors[][remove]', component.C.form.selected.co_inventors[i].remove || false)
                  }

                  if (component.C.form.selected.$collaborator.$item && component.C.form.selected.$collaborator.access) {
                    submitBlob.append('co_inventors[][user_id]', component.C.form.selected.$collaborator.$item.id)
                    submitBlob.append('co_inventors[][access]', component.C.form.selected.$collaborator.access)
                    submitBlob.append('co_inventors[][remove]', false)
                  }

                  if (component.C.form.selected.invention.$search.title) {
                    submitBlob.append('searches[][id]', null)
                    submitBlob.append('searches[][title]', component.C.form.selected.invention.$search.title)
                    submitBlob.append('searches[][url]', component.C.form.selected.invention.$search.url)
                    submitBlob.append('searches[][note]', component.C.form.selected.invention.$search.note)
                    submitBlob.append('searches[][tag]', component.C.form.selected.invention.$search.tag)
                    submitBlob.append('searches[][remove]', false)
                  }

                  if (component.C.form.selected.invention.bulk_read_access) {
                    submitBlob.append('invention[bulk_read_access]', component.C.form.selected.invention.bulk_read_access)
                  }
                } else {
                  var targetOpportunityID = (component.C.data.invention.opportunity && component.C.data.invention.opportunity.id)

                  if (targetOpportunityID === -1) {
                    submitBlob.append('invention[invention_opportunity_id]', 'other')
                  } else {
                    submitBlob.append('invention[invention_opportunity_id]', targetOpportunityID)
                  }

                  if (component.C.data.invention.bulk_read_access) {
                    submitBlob.append('invention[bulk_read_access]', component.C.data.invention.bulk_read_access)
                  }
                }

                axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/update`, submitBlob)
                    .then(function (response) {
                      console.info('Manage Invention Results: ', response.data)

                      callback(response.data)
                    })
                    .catch(function (errorResponse) {
                      tools.alert({
                        type: 'error',
                        errorResponse: errorResponse
                      })
                    })
              },
              addComment: () => {
                var component = this

                var apiCallPromise = null

                var submitBlob = new FormData()
                submitBlob.append('invention_id', component.C.form.selected.invention_id)
                submitBlob.append('content', component.C.form.selected.comments.content)

                apiCallPromise = axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/add_comment`, submitBlob)

                if (apiCallPromise) {
                  apiCallPromise
                    .then(function (response) {
                      console.info('Add Comment Results: ', response.data)

                      component.C.form.selected.comments.$list = (response.data && response.data.data && response.data.data.invention && response.data.data.invention.comments) || []

                      component.C.form.selected.comments.content = ''
                    })
                    .catch(function (errorResponse) {
                      tools.alert({
                        type: 'error',
                        errorResponse: errorResponse
                      })
                    })
                }
              },
              markInventionComplete: () => {
                var component = this

                if (component.C.data.invention.phase === 'phase-4' && component.C.data.invention.role === 'Mentor') {
                  axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/update_phase`, {
                    invention_id: component.$route.params.id,
                    phase: 'phase-5'
                  })
                    .then(function (response) {
                      console.info('Update Phase Results: ', response.data)

                      component.C.trigger.setupInvention()

                      tools.alert({
                        type: 'success',
                        message: `The status for ${component.C.form.selected.invention.title} has been set to Invention Complete.`
                      })
                    })
                    .catch(function (errorResponse) {
                      tools.alert({
                        type: 'error',
                        message: `Changes to ${component.C.form.selected.invention.title} have been saved, but status failed to be updated to Invention Review.`,
                        errorResponse: errorResponse
                      })
                    })
                }
              },
              saveAll: (isPresentation) => {
                var component = this

                clearTimeout(component.C.timer.autoSave)

                component.C.form.trigger.saveSidePanelItems(function (sidePanelResponse) {
                  component.C.form.trigger.updateAllContainerSections(function (containerSectionResponse) {
                    component.C.form.state.recentSaveActive = true

                    if (isPresentation) {
                      component.$router.push({
                        name: 'InventionPresentation',
                        params: {
                          id: component.$route.params.id
                        }
                      })
                    } else {
                      component.C.trigger.setupInvention()

                      tools.alert({
                        type: 'success',
                        message: `Changes to ${component.C.form.selected.invention.title} have been saved.`
                      })
                    }

                    clearTimeout(component.C.timer.saveIndicator)

                    component.C.timer.saveIndicator = setTimeout(function () {
                      component.C.form.state.recentSaveActive = false
                    }, 5000)
                  })
                })
              }
            }
          },
          report: {
            checklist: {
              percentage: 0,
              overview: {
                brief: {
                  completionAll: false,
                  searchOne: false
                },
                full: {
                  completionAll: false,
                  searchTwo: false,
                  mentorOne: false
                },
                review: {
                  mentorComplete: false
                }
              },
              detailed: {
                containerSections: {
                  summary: false,
                  draw: false,
                  significance: false,
                  problem_summary: false,
                  gap: false,
                  problem_significance: false,
                  landscape: false,
                  comparativeadvantages_innovativeaspects: false,
                  comparativeadvantages_advantagessummary: false,
                  comparativeadvantages_relevantbackground: false,
                  construction_howused: false,
                  construction_prototype: false,
                  economics_need: false,
                  economics_enduser: false,
                  economics_keyresources: false,
                  economics_capitalexpenditure: false,
                  economics_feasiblyeconomical: false,
                  economics_whomake: false,
                  economics_howmakemoney: false,
                  economics_howdelivered: false,
                  economics_economicburden: false,
                  economics_currentsolutioncosts: false,
                  economics_consumercosts: false,
                  specificquestions: false,
                  references: false
                },
                componentContainers: {
                  c_comparativeadvantages: {
                    complete: 0,
                    amount: 0
                  },
                  c_construction: {
                    complete: 0,
                    amount: 0
                  },
                  c_development: {
                    complete: 0,
                    amount: 0
                  }
                },
                searchCount: {
                  one: false,
                  two: false
                },
                mentorCount: {
                  one: false
                }
              }
            }
          },
          trigger: {
            openChecklist: () => {
              var component = this

              function checkContainerBulkCompletion (targetContainer) {
                targetContainer.components = targetContainer.components || []

                var isComplete = false
                var completionCount = 0
                var amountCount = 0

                if (targetContainer.components.length > 0) {
                  isComplete = true

                  for (var i = 0; i < targetContainer.components.length; i++) {
                    isComplete = isComplete && targetContainer.components[i].completion

                    if (targetContainer.components[i].completion) {
                      completionCount++
                    }

                    amountCount++
                  }
                }

                return {
                  isComplete: isComplete,
                  count: {
                    completion: completionCount,
                    amount: amountCount
                  }
                }
              }

              component.C.report.checklist.percentage = 0

              if (component.C.form.selected.invention.title) {
                component.C.report.checklist.percentage += 5
              }
              if (component.C.form.selected.invention.description) {
                component.C.report.checklist.percentage += 5
              }
              if (component.C.form.selected.invention.invention_opportunity_id) {
                component.C.report.checklist.percentage += 5
              }

              var componentContainersResults = {
                comparativeadvantages: checkContainerBulkCompletion(component.C.form.selected.invention.container_section.c_comparativeadvantages),
                construction: checkContainerBulkCompletion(component.C.form.selected.invention.container_section.c_construction),
                development: checkContainerBulkCompletion(component.C.form.selected.invention.container_section.c_development)
              }

              component.C.report.checklist.overview.brief.completionAll = false
              component.C.report.checklist.overview.brief.searchOne = false
              component.C.report.checklist.overview.full.completionAll = false
              component.C.report.checklist.overview.full.searchTwo = false
              component.C.report.checklist.overview.full.mentorOne = false
              component.C.report.checklist.overview.review.mentorComplete = false

              component.C.report.checklist.detailed.containerSections.summary = component.C.form.selected.invention.container_section.summary.completion || false
              component.C.report.checklist.detailed.containerSections.draw = component.C.form.selected.invention.container_section.draw.completion || false
              component.C.report.checklist.detailed.containerSections.significance = component.C.form.selected.invention.container_section.significance.completion || false
              component.C.report.checklist.detailed.containerSections.problem_summary = component.C.form.selected.invention.container_section.problem_summary.completion || false
              component.C.report.checklist.detailed.containerSections.gap = component.C.form.selected.invention.container_section.gap.completion || false
              component.C.report.checklist.detailed.containerSections.problem_significance = component.C.form.selected.invention.container_section.problem_significance.completion || false
              component.C.report.checklist.detailed.containerSections.landscape = component.C.form.selected.invention.container_section.landscape.completion || false
              component.C.report.checklist.detailed.containerSections.comparativeadvantages_innovativeaspects = component.C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.completion || false
              component.C.report.checklist.detailed.containerSections.comparativeadvantages_advantagessummary = component.C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.completion || false
              component.C.report.checklist.detailed.containerSections.comparativeadvantages_relevantbackground = component.C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.completion || false
              component.C.report.checklist.detailed.containerSections.construction_howused = component.C.form.selected.invention.container_section.construction_howused.completion || false
              component.C.report.checklist.detailed.containerSections.construction_prototype = component.C.form.selected.invention.container_section.construction_prototype.completion || false
              component.C.report.checklist.detailed.containerSections.economics_need = component.C.form.selected.invention.container_section.economics_need.completion || false
              component.C.report.checklist.detailed.containerSections.economics_enduser = component.C.form.selected.invention.container_section.economics_enduser.completion || false
              component.C.report.checklist.detailed.containerSections.economics_keyresources = component.C.form.selected.invention.container_section.economics_keyresources.completion || false
              component.C.report.checklist.detailed.containerSections.economics_capitalexpenditure = component.C.form.selected.invention.container_section.economics_capitalexpenditure.completion || false
              component.C.report.checklist.detailed.containerSections.economics_feasiblyeconomical = component.C.form.selected.invention.container_section.economics_feasiblyeconomical.completion || false
              component.C.report.checklist.detailed.containerSections.economics_whomake = component.C.form.selected.invention.container_section.economics_whomake.completion || false
              component.C.report.checklist.detailed.containerSections.economics_howmakemoney = component.C.form.selected.invention.container_section.economics_howmakemoney.completion || false
              component.C.report.checklist.detailed.containerSections.economics_howdelivered = component.C.form.selected.invention.container_section.economics_howdelivered.completion || false
              component.C.report.checklist.detailed.containerSections.economics_economicburden = component.C.form.selected.invention.container_section.economics_economicburden.completion || false
              component.C.report.checklist.detailed.containerSections.economics_currentsolutioncosts = component.C.form.selected.invention.container_section.economics_currentsolutioncosts.completion || false
              component.C.report.checklist.detailed.containerSections.economics_consumercosts = component.C.form.selected.invention.container_section.economics_consumercosts.completion || false
              component.C.report.checklist.detailed.containerSections.specificquestions = component.C.form.selected.invention.container_section.specificquestions.completion || false
              component.C.report.checklist.detailed.containerSections.references = component.C.form.selected.invention.container_section.references.completion || false
              component.C.report.checklist.detailed.componentContainers.c_comparativeadvantages.complete = componentContainersResults.comparativeadvantages.count.completion || 0
              component.C.report.checklist.detailed.componentContainers.c_comparativeadvantages.amount = componentContainersResults.comparativeadvantages.count.amount || 0
              component.C.report.checklist.detailed.componentContainers.c_construction.complete = componentContainersResults.construction.count.completion || 0
              component.C.report.checklist.detailed.componentContainers.c_construction.amount = componentContainersResults.construction.count.amount || 0
              component.C.report.checklist.detailed.componentContainers.c_development.complete = componentContainersResults.development.count.completion || 0
              component.C.report.checklist.detailed.componentContainers.c_development.amount = componentContainersResults.development.count.amount || 0
              component.C.report.checklist.detailed.searchCount.one = false
              component.C.report.checklist.detailed.searchCount.two = false
              component.C.report.checklist.detailed.mentorCount.one = false

              function incrementPercentage (containerIndex, targetKey, isContainer) {
                if (isContainer) {
                  if (component.C.report.checklist.detailed.componentContainers[`c_${targetKey}`].complete !== 0 && (component.C.report.checklist.detailed.componentContainers[`c_${targetKey}`].complete === component.C.report.checklist.detailed.componentContainers[`c_${targetKey}`].amount)) {
                    component.C.report.checklist.percentage += 3
                  }
                } else {
                  if (component.C.report.checklist.detailed.containerSections[targetKey] && (targetKey !== 'construction_prototype')) {
                    if (containerIndex === 0 || containerIndex === 1) {
                      component.C.report.checklist.percentage += 4
                    } else {
                      component.C.report.checklist.percentage += 1.5
                    }
                  }
                }
              }

              for (var i = 0; i < component.C.state.container.length; i++) {
                var currentContainer = component.C.state.container[i]

                if (currentContainer.componentContainerKey) {
                  incrementPercentage(i, currentContainer.componentContainerKey, true)
                }

                for (var j = 0; j < currentContainer.items.length; j++) {
                  if (currentContainer.items[j].includeAPI) {
                    incrementPercentage(i, currentContainer.items[j].key)
                  }
                  if (currentContainer.items[j].subAPIitems && currentContainer.items[j].subAPIitems.length > 0) {
                    for (var k = 0; k < currentContainer.items[j].subAPIitems.length; k++) {
                      incrementPercentage(i, currentContainer.items[j].subAPIitems[k].key)
                    }
                  }
                }
              }

              if (component.C.form.selected.invention.container_section.summary.completion && component.C.form.selected.invention.container_section.draw.completion && component.C.form.selected.invention.container_section.significance.completion && component.C.form.selected.invention.container_section.problem_summary.completion && component.C.form.selected.invention.container_section.gap.completion && component.C.form.selected.invention.container_section.problem_significance.completion) {
                component.C.report.checklist.percentage += 1
                component.C.report.checklist.overview.brief.completionAll = true
              }
              if (component.C.form.selected.invention.search.length >= 1) {
                component.C.report.checklist.percentage += 5
                component.C.report.checklist.overview.brief.searchOne = true
                component.C.report.checklist.detailed.searchCount.one = true
              }

              if (component.C.form.selected.invention.container_section.landscape.completion && component.C.form.selected.invention.container_section.comparativeadvantages_innovativeaspects.completion && component.C.form.selected.invention.container_section.comparativeadvantages_advantagessummary.completion && component.C.form.selected.invention.container_section.comparativeadvantages_relevantbackground.completion && component.C.form.selected.invention.container_section.construction_howused.completion && component.C.form.selected.invention.container_section.economics_need.completion && component.C.form.selected.invention.container_section.economics_enduser.completion && component.C.form.selected.invention.container_section.economics_keyresources.completion && component.C.form.selected.invention.container_section.economics_capitalexpenditure.completion && component.C.form.selected.invention.container_section.economics_feasiblyeconomical.completion && component.C.form.selected.invention.container_section.economics_whomake.completion && component.C.form.selected.invention.container_section.economics_howmakemoney.completion && component.C.form.selected.invention.container_section.economics_howdelivered.completion && component.C.form.selected.invention.container_section.economics_economicburden.completion && component.C.form.selected.invention.container_section.economics_currentsolutioncosts.completion && component.C.form.selected.invention.container_section.economics_consumercosts.completion && component.C.form.selected.invention.container_section.specificquestions.completion && component.C.form.selected.invention.container_section.references.completion && componentContainersResults.comparativeadvantages.isComplete && componentContainersResults.construction.isComplete && componentContainersResults.development.isComplete) {
                component.C.report.checklist.percentage += 4
                component.C.report.checklist.overview.full.completionAll = true
              }
              if (component.C.form.selected.invention.search.length >= 2) {
                component.C.report.checklist.percentage += 5
                component.C.report.checklist.overview.full.searchTwo = true
                component.C.report.checklist.detailed.searchCount.two = true
              }
              if (_.find(component.C.form.selected.co_inventors, function (collaborator) {
                return (parseInt(collaborator.access) === 2)
              })) {
                component.C.report.checklist.percentage += 5
                component.C.report.checklist.overview.full.mentorOne = true
                component.C.report.checklist.detailed.mentorCount.one = true
              }

              if (component.C.data.invention.phase === 'phase-5') {
                component.C.report.checklist.percentage += 5
                component.C.report.checklist.overview.review.mentorComplete = true
              }

              var isPhase = {
                one: (component.C.data.invention.phase === 'phase-1' || component.C.data.invention.phase === 'phase-2' || component.C.data.invention.phase === 'phase-3' || component.C.data.invention.phase === 'phase-4' || component.C.data.invention.phase === 'phase-5'),
                two: (component.C.data.invention.phase === 'phase-2' || component.C.data.invention.phase === 'phase-3' || component.C.data.invention.phase === 'phase-4' || component.C.data.invention.phase === 'phase-5'),
                three: (component.C.data.invention.phase === 'phase-3' || component.C.data.invention.phase === 'phase-4' || component.C.data.invention.phase === 'phase-5'),
                four: (component.C.data.invention.phase === 'phase-4' || component.C.data.invention.phase === 'phase-5'),
                five: (component.C.data.invention.phase === 'phase-5')
              }

              function updatePhase (targetPhase) {
                axios.put(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/update_phase`, {
                  invention_id: component.$route.params.id,
                  phase: targetPhase
                })
                  .then(function (response) {
                    console.info('Update Phase Results: ', response.data)

                    var inventionItem = (response && response.data && response.data.data && response.data.data.invention) || {}

                    if (inventionItem.phase) {
                      component.C.data.invention.phase = inventionItem.phase

                      tools.alert({
                        type: 'success',
                        message: `Invention ${component.C.form.selected.invention.title} has been upgraded to ${component.C.dictionary.phase[component.C.data.invention.phase]}.`
                      })
                    }
                  })
                  .catch(function (errorResponse) {
                    tools.alert({
                      type: 'error',
                      message: `Invention ${component.C.form.selected.invention.title} has failed to shift phases.  Please try refreshing the page.`,
                      errorResponse: errorResponse
                    })
                  })
              }

              if (isPhase.two && !isPhase.three && (
                component.C.report.checklist.overview.brief.completionAll && component.C.report.checklist.overview.brief.searchOne
              )) {
                updatePhase('phase-3')
              } else if (isPhase.three && !isPhase.four && (
                component.C.report.checklist.overview.brief.completionAll && component.C.report.checklist.overview.brief.searchOne
              ) && (
                component.C.report.checklist.overview.full.completionAll && component.C.report.checklist.overview.full.searchTwo && component.C.report.checklist.overview.full.mentorOne
              )) {
                updatePhase('phase-4')
              }
            },
            scrollToTop: () => {
              document.body.scrollTop = document.documentElement.scrollTop = 0
            },
            setupInvention: (isInitialization) => {
              var component = this

              axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/inventions/detail`, {
                params: {
                  invention_id: component.$route.params.id
                }
              })
                   .then(response => {
                     var inventionDataItem = (response && response.data && response.data.data && response.data.data.invention) || {}
                     var isEditable = (response && response.data && response.data.data && response.data.data.is_editable) || false

                     component.C.data.invention = inventionDataItem
                     component.C.state.isEditable = isEditable

                     component.C.form.selected.invention_id = inventionDataItem.id
                     component.C.form.selected.invention.title = inventionDataItem.title
                     component.C.form.selected.invention.description = inventionDataItem.description
                     component.C.form.selected.invention.keywords = (inventionDataItem.keywords || '')
                     component.C.form.selected.invention.search_results = (inventionDataItem.search_results || '')
                     component.C.form.selected.invention.action = inventionDataItem.action
                     component.C.form.selected.invention.action_note = inventionDataItem.action_note
                     component.C.form.selected.invention.search = inventionDataItem.searches // ### Incomplete
                     component.C.form.selected.invention.uploaded_filename = inventionDataItem.uploaded_filename

                     var targetOpportunityID = (inventionDataItem.opportunity && inventionDataItem.opportunity.id)
                     if (targetOpportunityID === -1) {
                       component.C.form.selected.invention.invention_opportunity_id = '$other'
                     } else {
                       component.C.form.selected.invention.invention_opportunity_id = targetOpportunityID
                     }

                     component.C.form.selected.invention.organization_id = (inventionDataItem.organization && inventionDataItem.organization.id)
                     component.C.form.selected.invention.bulk_read_access = inventionDataItem.bulk_read_access || null
                     component.C.form.selected.scratchpad = (inventionDataItem.scratchpad && inventionDataItem.scratchpad.content) || ''

                     component.C.form.selected.co_inventors = []

                     for (var i = 0; i < inventionDataItem.co_inventors.length; i++) {
                       component.C.form.selected.co_inventors.push({
                         $name: `${inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.firstname} ${inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.lastname}`,
                         user_id: inventionDataItem.co_inventors[i].user && inventionDataItem.co_inventors[i].user.id,
                         access: inventionDataItem.co_inventors[i].access
                       })
                     }

                     component.C.form.selected.comments.$list = inventionDataItem.comments

                     var containerSectionItem = inventionDataItem.container_section || {}

                     function presetContainerSection (targetKey) {
                       containerSectionItem[targetKey] = containerSectionItem[targetKey] || {
                         content: ''
                       }
                     }

                     for (i = 0; i < component.C.config.containerSections.length; i++) {
                       presetContainerSection(component.C.config.containerSections[i])
                     }

                     containerSectionItem.c_comparativeadvantages = containerSectionItem.c_comparativeadvantages || {
                       components: []
                     }
                     containerSectionItem.c_construction = containerSectionItem.c_construction || {
                       components: []
                     }
                     containerSectionItem.c_development = containerSectionItem.c_development || {
                       components: []
                     }

                     component.C.state.container[2].items = []
                     for (i = 0; i < containerSectionItem.c_comparativeadvantages.components.length; i++) {
                       var componentItem = containerSectionItem.c_comparativeadvantages.components[i]

                       component.C.state.container[2].items.push({
                         key: componentItem.type,
                         title: componentItem.type, // ### TEMPORARY - Need label
                         href: `#comparativeadvantages-${i}`,
                         useByIndex: true
                       })
                     }
                     for (i = 0; i < component.C.state.container[2].$baseItems.length; i++) {
                       component.C.state.container[2].items.push(component.C.state.container[2].$baseItems[i])
                     }

                     component.C.state.container[3].items = []
                     for (i = 0; i < containerSectionItem.c_construction.components.length; i++) {
                       componentItem = containerSectionItem.c_construction.components[i]

                       component.C.state.container[3].items.push({
                         key: componentItem.type,
                         title: componentItem.type, // ### TEMPORARY - Need label
                         href: `#construction-${i}`,
                         useByIndex: true
                       })
                     }
                     for (i = 0; i < component.C.state.container[3].$baseItems.length; i++) {
                       component.C.state.container[3].items.push(component.C.state.container[3].$baseItems[i])
                     }

                     component.C.state.container[5].items = []
                     for (i = 0; i < containerSectionItem.c_development.components.length; i++) {
                       componentItem = containerSectionItem.c_development.components[i]

                       component.C.state.container[5].items.push({
                         key: componentItem.type,
                         title: componentItem.type, // ### TEMPORARY - Need label
                         href: `#development-${i}`,
                         useByIndex: true
                       })
                     }
                     for (i = 0; i < component.C.state.container[5].$baseItems.length; i++) {
                       component.C.state.container[5].items.push(component.C.state.container[5].$baseItems[i])
                     }

                     component.C.form.selected.invention.container_section = containerSectionItem

                     component.C.trigger.openChecklist()

                     if (isInitialization) {
                       component.C.state.tab.comparativeadvantages.active = 'comparativeadvantages-base'

                       if (containerSectionItem.c_construction.components.length === 0) {
                         component.C.state.tab.construction.active = 'construction-base'
                       } else {
                         component.C.state.tab.construction.active = 'construction-0'
                       }

                       if (containerSectionItem.c_development.components.length === 0) {
                         component.C.state.tab.development.active = 'development-base'
                       } else {
                         component.C.state.tab.development.active = 'development-0'
                       }

                       if (component.C.form.selected.invention.organization_id) {
                         axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/organizations/opportunities_and_inventors`, {
                           params: {
                             organization_id: component.C.form.selected.invention.organization_id
                           }
                         })
                              .then(response => {
                                var opportunitiesList = (response && response.data && response.data.data && response.data.data.invention_opportunities) || []
                                var peopleList = (response && response.data && response.data.data && response.data.data.inventors) || []

                                opportunitiesList.push({
                                  id: '$other',
                                  title: 'Other'
                                })

                                component.C.form.list.opportunities = opportunitiesList
                                component.C.form.list.inventors = peopleList

                                component.C.form.selected.$collaborator.$item = null
                                component.C.form.selected.$collaborator.access = null
                              })
                              .catch(errorResponse => {
                                tools.alert({
                                  type: 'error',
                                  errorResponse: errorResponse
                                })
                              })
                       }

                       setTimeout(function () {
                         component.C.state.initialized = true
                       }, 10000)
                     }
                   })
                   .catch(errorResponse => {
                     tools.alert({
                       type: 'error',
                       errorResponse: errorResponse
                     })
                   })
            },
            confirmComparativeadvantagesComponentDelete: _.noop,
            confirmConstructionComponentDelete: _.noop,
            confirmDevelopmentComponentDelete: _.noop
          },
          evaluate: {
            generalInfoIsChecked: (subItem) => {
              var component = this

              var isCheckedResults = true

              if (subItem.subAPIitems) {
                for (var i = 0; i < subItem.subAPIitems.length; i++) {
                  var targetSubAPIitem = subItem.subAPIitems[i]
                  var isTargetSectionComplete = (component.C.form.selected.invention.container_section && component.C.form.selected.invention.container_section[targetSubAPIitem.key] && component.C.form.selected.invention.container_section[targetSubAPIitem.key].completion) || false

                  if (!targetSubAPIitem.exemptRequired) {
                    isCheckedResults = isCheckedResults && isTargetSectionComplete
                  }
                }
              } else {
                isCheckedResults = false
              }

              return isCheckedResults
            }
          },
          dictionary: {
            phase: {
              'phase-1': 'Concept',
              'phase-2': 'Invention Brief',
              'phase-3': 'Invention Full',
              'phase-4': 'Invention Review',
              'phase-5': 'Invention Complete'
            },
            bulk_read_access: {
              'only-inventors': 'Specific people',
              'anyone-organization': 'Anyone can comment'
            }
          }
        }
      }
    },
    created () {
      var component = this

      function initializeContainerSection (targetKey) {
        component.C.form.selected.invention.container_section[targetKey] = {
          content: ''
        }
        component.C.config.containerSections.push(targetKey)
      }

      for (var i = 0; i < component.C.state.container.length; i++) {
        var currentContainer = component.C.state.container[i]
        currentContainer.$baseItems = currentContainer.items || []

        for (var j = 0; j < currentContainer.items.length; j++) {
          if (currentContainer.items[j].includeAPI) {
            initializeContainerSection(currentContainer.items[j].key)
          }
          if (currentContainer.items[j].subAPIitems && currentContainer.items[j].subAPIitems.length > 0) {
            for (var k = 0; k < currentContainer.items[j].subAPIitems.length; k++) {
              initializeContainerSection(currentContainer.items[j].subAPIitems[k].key)
            }
          }
        }
      }

      component.C.trigger.setupInvention(true)
    },
    beforeDestroy () {
      var component = this

      clearTimeout(component.C.timer.autoSave)
    },
    filters: {
      F_availableCollaborators: (currentList, selectedList) => {
        currentList = currentList || []
        var filteredList = []

        for (var i = 0; i < currentList.length; i++) {
          var currentCollaborator = currentList[i]

          var correspondingSelectedCollaborator = _.find(selectedList, function (selectedCollaborator) {
            return selectedCollaborator.user_id === currentCollaborator.id
          })

          if (!correspondingSelectedCollaborator) {
            filteredList.push(currentCollaborator)
          }
        }

        return filteredList
      },
      F_availableAccess: (currentList, targetPhase) => {
        var filteredList = []

        for (var i = 0; i < currentList.length; i++) {
          var currentCollaborator = currentList[i]

          if (currentCollaborator.value === 2) {
            if (targetPhase === 'phase-3' || targetPhase === 'phase-4' || targetPhase === 'phase-5') {
              filteredList.push(currentCollaborator)
            }
          } else {
            filteredList.push(currentCollaborator)
          }
        }

        return filteredList
      }
    }
  }
</script>
<style lang='scss', scoped>
  .side-panel {
    top: 64px;
  }
  ol {
    list-style-type: decimal;
    list-style-position: outside;
    margin-left: 0;
    margin-right: 0;
    padding-left: 1em;
  }
  .tabs__content {
    padding: 1em 0;
    transition: none;
  }
  article {
    font-size: 1.2em;
  }
  .invention__progress {
    width: 190px;
  }
  .editor__nav {
    .toolbar__title {
      font-weight: 600;
      letter-spacing: 0em;
    }
  }
  .editor__rightpanel {
    right: 1.5em;
  }
    .tabs__construction {
        .tabs__item {
            text-transform: capitalize !important;
        }
        .tabs__content {
            transition: none;
            -webkit-box-shadow:inset 0 1px 0 0 rgba(0,0,0,0.15);
            box-shadow:inset 0 1px 0 0 rgba(0,0,0,0.15);
        }
    }
  .editor__leftpanel {
  padding-top: 1.25em;
  padding-left: 0.5em;
  padding-bottom: 1.5em;
  .list__group:before,
  .list__group:after {
    display: none
  }
  .list__group__header .list__tile__title {
    font-size: 1.35em;
    font-weight: 600;
  }
  .list__group__header--active .list__tile__title {
    color: #00d732;
  }
  .list__group__header .text--disabled .list__tile__title {
    color: #434D58;
    font-weight: 400;
  }
  .list__group__items .list__tile__title {
    font-size: 1.25em;
    text-transform: capitalize;
    color: #687178;
  }
  .list__group__items .list__tile__action {
    min-width: 32px;
    color: #8D9AA3;
  }
}
.scrollactive-item:hover {
    border-left: 1px solid #00d732 !important;
}
.scrollactive-item.is-active .list__tile__title,
.scrollactive-item.is-active .list__tile__action{
    color: #434D58 !important;
    font-weight: 600;
}
.hide {
  display: none;
}
.search-list__close {
  margin-top: -10px
}
.invention-checklist {
  .subheading span {
    display: inline-block;
    color: white;
    border-radius: 2px;
    font-weight: normal;
    font-size: 0.8em;
    padding: 0 0.5em;
    vertical-align: text-top;
    margin-left: 0.25em;
  }
}
.invention-checklist {
  div > ul > li,
  div > ol > li {
    padding: 0 0 1em 0;
  }
  ul li ul,
  ol li ul {
    padding-left: 1em;
  }
  ul li ul li,
  ol li ul li {
    padding: 0.3em 0;
    list-style-type: disc;
    list-style-position: inside;
    .icon {
      display: none;
    }
  }
}
.invention-checklist {
  ul li ul li.js-checklist-checked,

  ol li ul li.js-checklist-checked {
    list-style-type: none;
    .icon {
      margin-left: -5px;
      margin-right: 10px;
      display: inline-block;
      color: #222;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Inventions/Solution.vue